import { jsx as d, jsxs as M, Fragment as He } from "react/jsx-runtime";
import { useState as Q, useCallback as D, useRef as O, createContext as Gt, useContext as qt, useLayoutEffect as Ne, useEffect as z, useMemo as $t } from "react";
import { create as gn, useStore as vn } from "zustand";
import { createPortal as yn } from "react-dom";
const Fe = ["shift", "alt", "meta", "mod", "ctrl", "control"], bn = {
  esc: "escape",
  return: "enter",
  left: "arrowleft",
  right: "arrowright",
  up: "arrowup",
  down: "arrowdown",
  ShiftLeft: "shift",
  ShiftRight: "shift",
  AltLeft: "alt",
  AltRight: "alt",
  MetaLeft: "meta",
  MetaRight: "meta",
  OSLeft: "meta",
  OSRight: "meta",
  ControlLeft: "ctrl",
  ControlRight: "ctrl"
};
function G(t) {
  return (bn[t.trim()] || t.trim()).toLowerCase().replace(/key|digit|numpad/, "");
}
function Be(t) {
  return Fe.includes(t);
}
function Rt(t, e = ",") {
  return t.toLowerCase().split(e);
}
function jt(t, e = "+", n = ">", r = !1, i, o) {
  let s = [], f = !1;
  t = t.trim(), t.includes(n) ? (f = !0, s = t.toLocaleLowerCase().split(n).map((l) => G(l))) : s = t.toLocaleLowerCase().split(e).map((l) => G(l));
  const a = {
    alt: s.includes("alt"),
    ctrl: s.includes("ctrl") || s.includes("control"),
    shift: s.includes("shift"),
    meta: s.includes("meta"),
    mod: s.includes("mod"),
    useKey: r
  }, c = s.filter((l) => !Fe.includes(l));
  return {
    ...a,
    keys: c,
    description: i,
    isSequence: f,
    hotkey: t,
    metadata: o
  };
}
typeof document < "u" && (document.addEventListener("keydown", (t) => {
  t.code !== void 0 && ze([G(t.code)]);
}), document.addEventListener("keyup", (t) => {
  t.code !== void 0 && Ve([G(t.code)]);
})), typeof window < "u" && (window.addEventListener("blur", () => {
  Z.clear();
}), window.addEventListener("contextmenu", () => {
  setTimeout(() => {
    Z.clear();
  }, 0);
}));
const Z = /* @__PURE__ */ new Set();
function Qt(t) {
  return Array.isArray(t);
}
function wn(t, e = ",") {
  return (Qt(t) ? t : t.split(e)).every((n) => Z.has(n.trim().toLowerCase()));
}
function ze(t) {
  const e = Array.isArray(t) ? t : [t];
  Z.has("meta") && Z.forEach((n) => {
    Be(n) || Z.delete(n.toLowerCase());
  }), e.forEach((n) => {
    Z.add(n.toLowerCase());
  });
}
function Ve(t) {
  const e = Array.isArray(t) ? t : [t];
  t === "meta" ? Z.clear() : e.forEach((n) => {
    Z.delete(n.toLowerCase());
  });
}
function Sn(t, e, n) {
  (typeof n == "function" && n(t, e) || n === !0) && t.preventDefault();
}
function Tn(t, e, n) {
  return typeof n == "function" ? n(t, e) : n === !0 || n === void 0;
}
const Cn = [
  "input",
  "textarea",
  "select",
  "searchbox",
  "slider",
  "spinbutton",
  "menuitem",
  "menuitemcheckbox",
  "menuitemradio",
  "option",
  "radio",
  "textbox"
];
function xn(t) {
  return Ke(t, Cn);
}
function Ke(t, e = !1) {
  const { target: n, composed: r } = t;
  let i, o;
  return kn(n) && r ? (i = t.composedPath()[0] && t.composedPath()[0].tagName, o = t.composedPath()[0] && t.composedPath()[0].role) : (i = n && n.tagName, o = n && n.role), Qt(e) ? !!(i && e && e.some((s) => s.toLowerCase() === i.toLowerCase() || s === o)) : !!(i && e && e);
}
function kn(t) {
  return !!t.tagName && !t.tagName.startsWith("-") && t.tagName.includes("-");
}
function Ln(t, e) {
  return t.length === 0 && e ? !1 : e ? t.some((n) => e.includes(n)) || t.includes("*") : !0;
}
const En = (t, e, n = !1) => {
  const { alt: r, meta: i, mod: o, shift: s, ctrl: f, keys: a, useKey: c } = e, { code: l, key: u, ctrlKey: b, metaKey: m, shiftKey: p, altKey: h } = t, g = G(l);
  if (c && a?.length === 1 && a.includes(u.toLowerCase()))
    return !0;
  if (!a?.includes(g) && !["ctrl", "control", "unknown", "meta", "alt", "shift", "os"].includes(g))
    return !1;
  if (!n) {
    if (r !== h && g !== "alt" || s !== p && g !== "shift")
      return !1;
    if (o) {
      if (!m && !b)
        return !1;
    } else if (i !== m && g !== "meta" && g !== "os" || f !== b && g !== "ctrl" && g !== "control")
      return !1;
  }
  return a && a.length === 1 && a.includes(g) ? !0 : a && a.length > 0 ? a.includes(g) ? wn(a) : !1 : !a || a.length === 0;
}, _e = Gt(void 0), Mn = () => qt(_e);
function Pn({ addHotkey: t, removeHotkey: e, children: n }) {
  return /* @__PURE__ */ d(_e.Provider, { value: { addHotkey: t, removeHotkey: e }, children: n });
}
function Jt(t, e) {
  return t && e && typeof t == "object" && typeof e == "object" ? Object.keys(t).length === Object.keys(e).length && // @ts-expect-error TS7053
  Object.keys(t).reduce((n, r) => n && Jt(t[r], e[r]), !0) : t === e;
}
const $e = Gt({
  hotkeys: [],
  activeScopes: [],
  // This array has to be empty instead of containing '*' as default, to check if the provider is set or not
  toggleScope: () => {
  },
  enableScope: () => {
  },
  disableScope: () => {
  }
}), Dn = () => qt($e), In = ({ initiallyActiveScopes: t = ["*"], children: e }) => {
  const [n, r] = Q(t), [i, o] = Q([]), s = D((u) => {
    r((b) => b.includes("*") ? [u] : Array.from(/* @__PURE__ */ new Set([...b, u])));
  }, []), f = D((u) => {
    r((b) => b.filter((m) => m !== u));
  }, []), a = D((u) => {
    r((b) => b.includes(u) ? b.filter((m) => m !== u) : b.includes("*") ? [u] : Array.from(/* @__PURE__ */ new Set([...b, u])));
  }, []), c = D((u) => {
    o((b) => [...b, u]);
  }, []), l = D((u) => {
    o((b) => b.filter((m) => !Jt(m, u)));
  }, []);
  return /* @__PURE__ */ d(
    $e.Provider,
    {
      value: { activeScopes: n, hotkeys: i, enableScope: s, disableScope: f, toggleScope: a },
      children: /* @__PURE__ */ d(Pn, { addHotkey: c, removeHotkey: l, children: e })
    }
  );
};
function On(t) {
  const e = O(void 0);
  return Jt(e.current, t) || (e.current = t), e.current;
}
const ce = (t) => {
  t.stopPropagation(), t.preventDefault(), t.stopImmediatePropagation();
}, An = typeof window < "u" ? Ne : z;
function X(t, e, n, r) {
  const i = O(null), o = O(!1), s = Array.isArray(n) ? Array.isArray(r) ? void 0 : r : n, f = Qt(t) ? t.join(s?.delimiter) : t, a = Array.isArray(n) ? n : Array.isArray(r) ? r : void 0, c = D(e, a ?? []), l = O(c);
  a ? l.current = c : l.current = e;
  const u = On(s), { activeScopes: b } = Dn(), m = Mn();
  return An(() => {
    if (u?.enabled === !1 || !Ln(b, u?.scopes))
      return;
    let p = [], h;
    const g = (S, w = !1) => {
      if (!(xn(S) && !Ke(S, u?.enableOnFormTags))) {
        if (i.current !== null) {
          const y = i.current.getRootNode();
          if ((y instanceof Document || y instanceof ShadowRoot) && y.activeElement !== i.current && !i.current.contains(y.activeElement)) {
            ce(S);
            return;
          }
        }
        S.target?.isContentEditable && !u?.enableOnContentEditable || Rt(f, u?.delimiter).forEach((y) => {
          if (y.includes(u?.splitKey ?? "+") && y.includes(u?.sequenceSplitKey ?? ">")) {
            console.warn(
              `Hotkey ${y} contains both ${u?.splitKey ?? "+"} and ${u?.sequenceSplitKey ?? ">"} which is not supported.`
            );
            return;
          }
          const T = jt(
            y,
            u?.splitKey,
            u?.sequenceSplitKey,
            u?.useKey,
            u?.description,
            u?.metadata
          );
          if (T.isSequence) {
            h = setTimeout(() => {
              p = [];
            }, u?.sequenceTimeoutMs ?? 1e3);
            const L = T.useKey ? S.key : G(S.code);
            if (Be(L.toLowerCase()))
              return;
            p.push(L);
            const P = T.keys?.[p.length - 1];
            if (L !== P) {
              p = [], h && clearTimeout(h);
              return;
            }
            p.length === T.keys?.length && (l.current(S, T), h && clearTimeout(h), p = []);
          } else if (En(S, T, u?.ignoreModifiers) || T.keys?.includes("*")) {
            if (u?.ignoreEventWhen?.(S) || w && o.current)
              return;
            if (Sn(S, T, u?.preventDefault), !Tn(S, T, u?.enabled)) {
              ce(S);
              return;
            }
            l.current(S, T), w || (o.current = !0);
          }
        });
      }
    }, v = (S) => {
      S.code !== void 0 && (ze(G(S.code)), (u?.keydown === void 0 && u?.keyup !== !0 || u?.keydown) && g(S));
    }, x = (S) => {
      S.code !== void 0 && (Ve(G(S.code)), o.current = !1, u?.keyup && g(S, !0));
    }, k = i.current || s?.document || document;
    return k.addEventListener("keyup", x, s?.eventListenerOptions), k.addEventListener("keydown", v, s?.eventListenerOptions), m && Rt(f, u?.delimiter).forEach((S) => {
      m.addHotkey(
        jt(
          S,
          u?.splitKey,
          u?.sequenceSplitKey,
          u?.useKey,
          u?.description,
          u?.metadata
        )
      );
    }), () => {
      k.removeEventListener("keyup", x, s?.eventListenerOptions), k.removeEventListener("keydown", v, s?.eventListenerOptions), m && Rt(f, u?.delimiter).forEach((S) => {
        m.removeHotkey(
          jt(
            S,
            u?.splitKey,
            u?.sequenceSplitKey,
            u?.useKey,
            u?.description,
            u?.metadata
          )
        );
      }), p = [], h && clearTimeout(h);
    };
  }, [f, u, b]), i;
}
const Xe = "WEAVE_TIMELINE_HOTKEYS_SCOPE", Wn = 16;
function st(t, e, n) {
  if (t <= e) return 0;
  const r = Wn / n;
  return t - e + r;
}
function Rn(t, e, n) {
  return {
    start: t,
    end: Math.min(t + e, n)
  };
}
function jn(t, e, n) {
  return e + t / n;
}
const Hn = 80;
function Nn(t) {
  const e = 1 / t;
  return [
    [5 * e, e],
    // labels every 5 frames,  minor every 1 frame
    [10 * e, 5 * e],
    // labels every 10 frames, minor every 5 frames
    [1, 10 * e],
    // labels every 1s,        minor every 10 frames
    [5, 1],
    // labels every 5s,        minor every 1s
    [10, 5],
    // labels every 10s,       minor every 5s
    [30, 10],
    // labels every 30s,       minor every 10s
    [60, 30],
    // labels every 1min,      minor every 30s
    [300, 60],
    // labels every 5min,      minor every 1min
    [600, 300]
    // labels every 10min,     minor every 5min
  ];
}
function Fn(t, e) {
  const n = Nn(e);
  let r = n[n.length - 1];
  for (const f of n)
    if (f[0] * t >= Hn) {
      r = f;
      break;
    }
  const [i, o] = r, s = o < 1;
  return { interval: o, majorInterval: i, showFrames: s };
}
function Bn(t, e, n, r, i) {
  const o = [], s = Math.round(r * i), f = Math.ceil(t / n) * n;
  for (let a = f; a <= e; a += n) {
    const c = Math.round(a * i) / i, u = Math.round(c * i) % s === 0;
    o.push({
      time: c,
      isMajor: u,
      label: u ? zn(c, i) : void 0
    });
  }
  return o;
}
function zn(t, e) {
  const n = Math.round(t * e), r = Math.round(e), i = Math.floor(n / r), o = n - i * r, s = Math.floor(i / 3600), f = Math.floor(i % 3600 / 60), a = i % 60;
  if (o > 0) {
    const l = (u) => String(u).padStart(2, "0");
    return `${l(a)}:${l(o)}`;
  }
  let c = "";
  return s > 0 && (c += `${s}h`), (s > 0 || f > 0) && (c += `${f}m`), c += `${a}s`, c;
}
function Ze(t, e, n, r, i, o) {
  const s = t * e, f = i / s, a = (n - r) / (i / t), c = n - a * f, l = o / f, u = st(i, f, l), b = Math.max(0, Math.min(c, u));
  return { newZoom: s, newScroll: b };
}
const U = 30, Vn = 240, le = 16, te = 36, Zo = 40, Ht = 32, vt = 4, ue = 6, de = 0.16, Ye = 8, Ue = 250, Kn = 28, fe = 20, Ge = 92, qe = 8, pe = 1.5, _n = 0.01, Qe = 20, it = 1;
function Nt(t, e, n) {
  const r = t / e, i = r > 0 ? n / r : 0;
  return { visibleDuration: r, pps: i, maxScroll: st(t, r, i) };
}
function $n() {
  return gn((t, e) => ({
    // Media metadata
    duration: 0,
    frameRate: 30,
    // Playback state
    currentTime: 0,
    isPlaying: !1,
    // Zoom/scroll state
    zoomLevel: 1,
    scrollPosition: 0,
    containerWidth: 0,
    // Tracks
    tracks: [],
    // Snap indicator
    snapIndicatorTime: null,
    // Drag guard
    draggingTrackId: null,
    // Actions
    setMetadata(n, r = 30) {
      t({
        duration: n,
        frameRate: r,
        currentTime: 0,
        isPlaying: !1,
        zoomLevel: 1,
        scrollPosition: 0
      });
    },
    setDuration(n) {
      const { zoomLevel: r, scrollPosition: i, containerWidth: o } = e(), { maxScroll: s } = Nt(n, r, o);
      t({
        duration: n,
        scrollPosition: Math.min(i, s)
      });
    },
    setCurrentTime(n) {
      const { duration: r, currentTime: i, isPlaying: o, zoomLevel: s, scrollPosition: f } = e(), a = Math.max(0, Math.min(n, r));
      if (i !== a) {
        if (o) {
          const c = r / s;
          if (a < f) {
            t({ currentTime: a, scrollPosition: a });
            return;
          } else if (a > f + c) {
            t({ currentTime: a, scrollPosition: a - c * 0.9 });
            return;
          }
        }
        t({ currentTime: a });
      }
    },
    setPlaying(n) {
      e().isPlaying !== n && t({ isPlaying: n });
    },
    setZoomLevel(n) {
      const { duration: r, frameRate: i, scrollPosition: o, containerWidth: s } = e(), f = r * i / Qe, a = Math.max(it, Math.min(n, f)), { maxScroll: c } = Nt(r, a, s);
      t({
        zoomLevel: a,
        scrollPosition: Math.min(o, c)
      });
    },
    setScrollPosition(n) {
      const { duration: r, zoomLevel: i, containerWidth: o } = e(), { maxScroll: s } = Nt(r, i, o);
      t({ scrollPosition: Math.max(0, Math.min(n, s)) });
    },
    setContainerWidth(n) {
      t({ containerWidth: n });
    },
    setTrackStartTime(n, r) {
      const i = e().tracks.map((o) => o.id === n ? { ...o, startTime: r } : o);
      t({ tracks: i });
    },
    setTrackTrim(n, r) {
      const i = e().tracks.map((o) => o.id === n ? { ...o, ...r } : o);
      t({ tracks: i });
    },
    setTracks(n) {
      const { draggingTrackId: r } = e();
      if (r != null) {
        const i = e().tracks.find((o) => o.id === r);
        i && (n = n.map(
          (o) => o.id === r ? {
            ...o,
            startTime: i.startTime,
            duration: i.duration,
            trimStart: i.trimStart,
            trimEnd: i.trimEnd
          } : o
        ));
      }
      t({ tracks: n });
    },
    setSnapIndicatorTime(n) {
      t({ snapIndicatorTime: n });
    },
    setDraggingTrackId(n) {
      t({ draggingTrackId: n });
    }
  }));
}
const St = (t) => t.duration / t.zoomLevel, $ = (t) => {
  const e = t.duration / t.zoomLevel;
  return e > 0 ? t.containerWidth / e : 0;
}, Je = (t) => t.duration * t.frameRate / Qe, tn = Gt(null);
function V() {
  const t = qt(tn);
  if (!t)
    throw new Error("useTimelineContext must be used within a <TimelineProvider>");
  return t;
}
function C(t) {
  const { store: e } = V();
  return vn(e, t);
}
function Yo({
  children: t,
  duration: e,
  frameRate: n = 30,
  currentTime: r,
  isPlaying: i,
  onSeek: o,
  onPlayingChange: s,
  tracks: f,
  selectedTrackId: a,
  onTrackLockToggle: c,
  onTrackMuteToggle: l,
  onTrackVisibilityToggle: u,
  onTrackStartTimeChange: b,
  onTrackTrimChange: m,
  onTrackSelect: p,
  onTrackReorder: h
}) {
  const g = $t(() => $n(), []), v = O(!1);
  z(() => {
    if (!e || !Number.isFinite(e)) return;
    const y = g.getState();
    y.duration === e && y.frameRate === n || (v.current = !0, y.setMetadata(e, n), v.current = !1);
  }, [g, e, n]);
  const x = O(r), k = O(i);
  x.current = r, k.current = i, z(() => {
    let y;
    function T() {
      const L = x.current;
      if (L != null) {
        const { currentTime: W, duration: E } = g.getState(), I = Math.max(0, Math.min(L, E));
        W !== I && g.getState().setCurrentTime(L);
      }
      const P = k.current;
      P != null && g.getState().isPlaying !== P && (v.current = !0, g.getState().setPlaying(P), v.current = !1), y = requestAnimationFrame(T);
    }
    return y = requestAnimationFrame(T), () => cancelAnimationFrame(y);
  }, [g]), z(() => {
    let y = g.getState().isPlaying;
    return g.subscribe((T) => {
      T.isPlaying !== y && (y = T.isPlaying, v.current || s(T.isPlaying));
    });
  }, [g, s]), z(() => {
    f && g.getState().setTracks(f);
  }, [f, g]);
  const S = a ?? null, w = $t(
    () => ({
      store: g,
      onSeek: o,
      onTrackLockToggle: c,
      onTrackMuteToggle: l,
      onTrackVisibilityToggle: u,
      onTrackStartTimeChange: b,
      onTrackTrimChange: m,
      onTrackSelect: p,
      onTrackReorder: h,
      selectedTrackId: S
    }),
    [
      g,
      o,
      c,
      l,
      u,
      b,
      m,
      p,
      h,
      S
    ]
  );
  return /* @__PURE__ */ d(In, { initiallyActiveScopes: [Xe], children: /* @__PURE__ */ d(tn.Provider, { value: w, children: t }) });
}
function Xn({ togglePlay: t, stepFrame: e }) {
  const n = C((p) => p.isPlaying), r = C((p) => p.setPlaying), i = C((p) => p.setCurrentTime), o = C((p) => p.tracks.length > 0), { store: s, onSeek: f, selectedTrackId: a, onTrackStartTimeChange: c } = V(), l = D(() => {
    n && r(!1);
  }, [n, r]), u = D(() => {
    o && (l(), i(0), f(0));
  }, [l, i, o, f]), b = D(() => {
    if (!o) return;
    l();
    const { duration: p } = s.getState();
    i(p), f(p);
  }, [l, i, o, s, f]), m = { enableOnFormTags: !1, scopes: [Xe] };
  X(
    "space",
    (p) => {
      p.preventDefault(), t();
    },
    m
  ), X(
    "meta+left, ctrl+left",
    (p) => {
      p.preventDefault(), e(-1);
    },
    m
  ), X(
    "meta+right, ctrl+right",
    (p) => {
      p.preventDefault(), e(1);
    },
    m
  ), X(
    "meta+shift+left, ctrl+shift+left",
    (p) => {
      p.preventDefault(), e(-10);
    },
    m
  ), X(
    "meta+shift+right, ctrl+shift+right",
    (p) => {
      p.preventDefault(), e(10);
    },
    m
  ), X(
    "meta+shift+alt+left, ctrl+shift+alt+left",
    (p) => {
      p.preventDefault(), u();
    },
    m
  ), X(
    "meta+shift+alt+right, ctrl+shift+alt+right",
    (p) => {
      p.preventDefault(), b();
    },
    m
  ), X(
    "BracketLeft",
    () => {
      if (a == null) return;
      const { currentTime: p } = s.getState();
      l(), c(a, p, !1);
    },
    m
  ), X(
    "BracketRight",
    () => {
      if (a == null) return;
      const { currentTime: p, tracks: h } = s.getState(), g = h.find((v) => v.id === a);
      g && (l(), c(a, p - g.duration, !1));
    },
    m
  );
}
const Zn = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M5.27734 2.44019C5.45049 2.44385 5.62082 2.48223 5.77832 2.55151L5.93066 2.63062L5.93262 2.63159L19.4375 10.8914C19.6282 11.0068 19.7861 11.1699 19.8955 11.364C20.0049 11.5581 20.0624 11.777 20.0625 11.9998C20.0625 12.2226 20.0049 12.4423 19.8955 12.6365C19.7865 12.8298 19.629 12.9909 19.4395 13.1062L5.93262 21.3679L5.93066 21.3689C5.7334 21.4886 5.50804 21.5544 5.27734 21.5593C5.04685 21.5642 4.81917 21.5084 4.61719 21.3972C4.46562 21.3138 4.33197 21.2014 4.22461 21.0671L4.12598 20.9255C4.00679 20.728 3.94178 20.5019 3.9375 20.2712V3.72827L3.95215 3.5564C3.97784 3.38663 4.03674 3.22294 4.12598 3.07495C4.24522 2.8774 4.41505 2.71457 4.61719 2.60327C4.81921 2.49208 5.04679 2.43536 5.27734 2.44019Z",
      fill: "currentColor"
    }
  )
] }), Yn = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d("g", { clipPath: "url(#clip0_822_591)", children: /* @__PURE__ */ d(
    "path",
    {
      d: "M9 3.96533C9.72479 3.96533 10.3124 4.55307 10.3125 5.27783V20.2778C10.3125 21.0027 9.72487 21.5903 9 21.5903H5.25C4.52513 21.5903 3.9375 21.0027 3.9375 20.2778V5.27783C3.93763 4.55307 4.52521 3.96533 5.25 3.96533H9ZM18.75 3.96533C19.4748 3.96533 20.0624 4.55307 20.0625 5.27783V20.2778C20.0625 21.0027 19.4749 21.5903 18.75 21.5903H15C14.2751 21.5903 13.6875 21.0027 13.6875 20.2778V5.27783C13.6876 4.55307 14.2752 3.96533 15 3.96533H18.75Z",
      fill: "currentColor"
    }
  ) }),
  /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ d("clipPath", { id: "clip0_822_591", children: /* @__PURE__ */ d("rect", { width: "24", height: "24", fill: "white", transform: "translate(0 0.777832)" }) }) })
] }), me = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M6 6.02246V18.0225",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M9 6.75811V17.2862C9.00114 17.4188 9.0378 17.5486 9.10616 17.6622C9.17451 17.7758 9.27206 17.869 9.38865 17.9321C9.50524 17.9951 9.63661 18.0258 9.76909 18.0209C9.90156 18.016 10.0303 17.9756 10.1419 17.904L18.4097 12.64C18.5139 12.574 18.5997 12.4828 18.6591 12.3748C18.7186 12.2668 18.7497 12.1455 18.7497 12.0222C18.7497 11.8989 18.7186 11.7776 18.6591 11.6696C18.5997 11.5615 18.5139 11.4703 18.4097 11.4044L10.1419 6.1403C10.0303 6.06873 9.90156 6.02839 9.76909 6.02346C9.63661 6.01854 9.50524 6.04921 9.38865 6.11229C9.27206 6.17538 9.17451 6.26856 9.10616 6.38214C9.0378 6.49572 9.00114 6.62555 9 6.75811Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] });
function nt({ style: t, component: e, ...n }) {
  switch (e) {
    case "span":
      return /* @__PURE__ */ d("span", { style: { display: "flex", ...t }, ...n });
    case "button":
      return /* @__PURE__ */ d("button", { style: { display: "flex", ...t }, ...n });
    default:
      return /* @__PURE__ */ d("div", { style: { display: "flex", ...t }, ...n });
  }
}
function Un({ style: t, ...e }) {
  return /* @__PURE__ */ d(nt, { style: { flexDirection: "column", ...t }, ...e });
}
function Gn({ style: t, ...e }) {
  return /* @__PURE__ */ d(nt, { style: { justifyContent: "center", ...t }, ...e });
}
function q({ style: t, ...e }) {
  return /* @__PURE__ */ d(nt, { style: { alignItems: "center", ...t }, ...e });
}
function ct({ style: t, ...e }) {
  return /* @__PURE__ */ d(Gn, { style: { alignItems: "center", ...t }, ...e });
}
const _ = "var(--Black92)", qn = "var(--Black40_T)", lt = "var(--White100)", bt = "var(--White80_T)", Tt = "var(--White64_T)", ut = "var(--White40_T)", Qn = "var(--White16_T)", N = "var(--White08_T)", Jn = "var(--White04_T)", en = "var(--Yellow100)", tr = "var(--Yellow64)", er = "#F1A0FA", nr = "#EF9092";
function at({ children: t, onClick: e, size: n = 24, disabled: r, ariaLabel: i, stopPropagation: o }) {
  return /* @__PURE__ */ d(
    ct,
    {
      component: "button",
      className: "icon-btn",
      style: {
        width: n,
        height: n,
        color: r ? ut : bt,
        borderRadius: 4
      },
      disabled: r,
      "aria-label": i,
      onClick: (a) => {
        o && a.stopPropagation(), e();
      },
      onMouseDown: (a) => {
        o && a.stopPropagation();
      },
      children: t
    }
  );
}
function rr({ options: t, value: e, onChange: n, size: r = 24 }) {
  const [i, o] = Q(null);
  return /* @__PURE__ */ d(He, { children: t.map((s, f) => {
    const a = s.value === e, c = i === f;
    let l = "transparent", u = bt;
    return a && c ? (l = tr, u = _) : a ? (l = en, u = _) : c && (l = N, u = lt), /* @__PURE__ */ d(
      ct,
      {
        component: "button",
        style: {
          width: r,
          height: r,
          padding: 0,
          borderRadius: 4,
          background: l,
          color: u
        },
        "aria-label": s.ariaLabel,
        onClick: () => n(s.value),
        onMouseEnter: () => o(f),
        onMouseLeave: () => o(null),
        children: s.icon
      },
      f
    );
  }) });
}
const or = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12.7459 12.7421L20.4662 10.5859C20.6175 10.5395 20.7503 10.4465 20.8455 10.3201C20.9407 10.1936 20.9935 10.0403 20.9963 9.8821C20.9992 9.72386 20.9518 9.56878 20.8612 9.43907C20.7705 9.30935 20.6411 9.21165 20.4915 9.15994L3.9915 3.03994C3.85914 2.99493 3.71682 2.9878 3.58063 3.01937C3.44443 3.05095 3.31977 3.11996 3.22072 3.21863C3.12166 3.31729 3.05216 3.44168 3.02005 3.57775C2.98794 3.71382 2.9945 3.85616 3.039 3.98869L9.159 20.4887C9.2107 20.6383 9.30841 20.7677 9.43812 20.8584C9.56783 20.949 9.72291 20.9964 9.88115 20.9935C10.0394 20.9907 10.1927 20.9379 10.3191 20.8427C10.4455 20.7475 10.5386 20.6147 10.5849 20.4634L12.7459 12.7421Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), ir = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M15.7501 7.125C15.7501 6.62772 15.9477 6.15081 16.2993 5.79917C16.6509 5.44754 17.1279 5.25 17.6251 5.25C18.1224 5.25 18.5993 5.44754 18.951 5.79917C19.3026 6.15081 19.5001 6.62772 19.5001 7.125V14.25C19.5001 15.2349 19.3061 16.2102 18.9292 17.1201C18.5523 18.0301 17.9999 18.8569 17.3034 19.5533C16.607 20.2497 15.7802 20.8022 14.8703 21.1791C13.9603 21.556 12.985 21.75 12.0001 21.75C7.85826 21.75 6.30482 19.755 3.25138 13.3125C3.00666 12.8821 2.94213 12.3723 3.07185 11.8945C3.20158 11.4167 3.51504 11.0096 3.94383 10.762C4.37262 10.5144 4.88193 10.4465 5.36061 10.5731C5.83928 10.6996 6.24848 11.0104 6.49888 11.4375L8.25013 14.25V5.625C8.25013 5.12772 8.44768 4.65081 8.79931 4.29917C9.15094 3.94754 9.62785 3.75 10.1251 3.75C10.6224 3.75 11.0993 3.94754 11.451 4.29917C11.8026 4.65081 12.0001 5.12772 12.0001 5.625",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 11.25V4.125C12 3.62772 12.1975 3.15081 12.5492 2.79917C12.9008 2.44754 13.3777 2.25 13.875 2.25C14.3723 2.25 14.8492 2.44754 15.2008 2.79917C15.5525 3.15081 15.75 3.62772 15.75 4.125V11.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), he = () => /* @__PURE__ */ d("div", { style: { width: "1px", height: "24px", background: N } }), ar = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M7.5 15.75H3C2.80109 15.75 2.61032 15.671 2.46967 15.5303C2.32902 15.3897 2.25 15.1989 2.25 15V9C2.25 8.80109 2.32902 8.61032 2.46967 8.46967C2.61032 8.32902 2.80109 8.25 3 8.25H7.5L14.25 3V21L7.5 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d("path", { d: "M7.5 8.25V15.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M18 10.0171C18.4825 10.5649 18.7487 11.2699 18.7487 11.9999C18.7487 12.7299 18.4825 13.4349 18 13.9827",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M20.7815 7.5C21.8884 8.73755 22.5003 10.3397 22.5003 12C22.5003 13.6603 21.8884 15.2624 20.7815 16.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), sr = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M22.1028 9.35278C22.3225 9.13311 22.678 9.13311 22.8977 9.35278C23.1171 9.57248 23.1173 9.92813 22.8977 10.1477L21.0452 12.0002L22.8977 13.8528L22.97 13.9407C23.114 14.159 23.0898 14.4556 22.8977 14.6477C22.7056 14.8398 22.409 14.864 22.1907 14.72L22.1028 14.6477L20.2502 12.7952L18.3977 14.6477C18.1781 14.8673 17.8225 14.8671 17.6028 14.6477C17.3831 14.428 17.3831 14.0725 17.6028 13.8528L19.4553 12.0002L17.6028 10.1477C17.3831 9.92804 17.3831 9.57245 17.6028 9.35278C17.8225 9.13311 18.178 9.13311 18.3977 9.35278L20.2502 11.2053L22.1028 9.35278Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M13.9043 2.55591C14.0739 2.42401 14.3041 2.40097 14.4971 2.49536C14.69 2.58978 14.8125 2.78547 14.8125 3.00024V21.0002C14.8124 21.215 14.69 21.4107 14.4971 21.5051C14.3041 21.5995 14.0739 21.5764 13.9043 21.4446L7.30664 16.3127H3C2.65194 16.3127 2.3184 16.1741 2.07227 15.928C1.82616 15.6819 1.68754 15.3483 1.6875 15.0002V9.00024C1.6875 8.65218 1.82617 8.31864 2.07227 8.07251C2.31841 7.82637 2.6519 7.68774 3 7.68774H7.30664L13.9043 2.55591ZM8.06152 8.52661V15.4729L13.6875 19.8489V4.15063L8.06152 8.52661ZM3 8.81274C2.95027 8.81274 2.90235 8.83227 2.86719 8.86743C2.83207 8.90259 2.8125 8.95055 2.8125 9.00024V15.0002L2.82715 15.0715C2.83648 15.0941 2.84957 15.1154 2.86719 15.1331C2.90234 15.1682 2.9503 15.1877 3 15.1877H6.93652V8.81274H3Z",
      fill: "currentColor"
    }
  )
] }), nn = ({
  onToggle: t,
  muted: e,
  size: n = "large",
  disabled: r
}) => {
  const i = n === "medium" ? 20 : 24, o = n === "medium" ? 14 : 18;
  return /* @__PURE__ */ d(at, { size: i, disabled: r, onClick: t, stopPropagation: !0, children: e ? /* @__PURE__ */ d(sr, { width: o, height: o }) : /* @__PURE__ */ d(ar, { width: o, height: o }) });
}, cr = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d("path", { d: "M9.75 4.5L6 8.25L2.25 4.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round" })
] });
function lr({ text: t, children: e }) {
  return /* @__PURE__ */ d("span", { style: { fontSize: "0.875rem", fontWeight: 400 }, children: t ?? e });
}
function ur({ text: t, children: e }) {
  return /* @__PURE__ */ d("span", { style: { fontSize: "0.75rem", fontWeight: 500 }, children: t ?? e });
}
function dr({ text: t, children: e }) {
  return /* @__PURE__ */ d("span", { style: { fontSize: "0.75rem", fontWeight: 400 }, children: t ?? e });
}
function fr({ text: t, children: e }) {
  return /* @__PURE__ */ d("span", { style: { fontSize: "0.625rem", fontWeight: 400, fontFamily: "'DM Mono', monospace" }, children: t ?? e });
}
const ge = 1.1;
function pr({ label: t, shortcut: e, action: n, onClose: r }) {
  return /* @__PURE__ */ d("div", { style: { padding: "0 4px" }, children: /* @__PURE__ */ M(
    "button",
    {
      className: "canvas-zoom-menu-item",
      style: {
        border: "none",
        boxSizing: "border-box",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "4px 8px",
        borderRadius: 4,
        cursor: "pointer",
        color: lt,
        fontSize: "0.75rem"
      },
      onClick: () => {
        n(), r();
      },
      children: [
        /* @__PURE__ */ d("span", { children: t }),
        /* @__PURE__ */ d("span", { style: { color: Tt }, children: `⌘ ${e}` })
      ]
    }
  ) });
}
function mr({ canvasZoom: t, onCanvasZoomChanged: e, onZoomToFit: n }) {
  const [r, i] = Q(!1), o = O(null), s = O(null);
  z(() => {
    if (!r) return;
    const p = (g) => {
      s.current?.contains(g.target) || o.current?.contains(g.target) || i(!1);
    }, h = (g) => {
      g.key === "Escape" && (g.stopPropagation(), i(!1));
    };
    return document.addEventListener("mousedown", p), document.addEventListener("keydown", h, !0), () => {
      document.removeEventListener("mousedown", p), document.removeEventListener("keydown", h, !0);
    };
  }, [r]);
  const f = D(() => e(t * ge), [e, t]), a = D(() => e(t / ge), [e, t]), c = D(() => e(1), [e]), l = D(() => i(!1), []), u = [
    { label: "Zoom in", shortcut: "+", action: f },
    { label: "Zoom out", shortcut: "−", action: a },
    { label: "Zoom to 100%", shortcut: "0", action: c },
    { label: "Zoom to fit", shortcut: "1", action: n }
  ], [b, m] = Q({ bottom: 0, right: 0 });
  return Ne(() => {
    if (!r || !o.current) return;
    const p = o.current.getBoundingClientRect();
    m({ bottom: window.innerHeight - p.top + 4, right: window.innerWidth - p.right });
  }, [r]), /* @__PURE__ */ M(He, { children: [
    /* @__PURE__ */ M(
      "button",
      {
        ref: o,
        style: {
          display: "flex",
          alignItems: "center",
          boxSizing: "border-box",
          justifyContent: "space-between",
          padding: "4px 8px",
          borderRadius: 4,
          width: "78px",
          cursor: "pointer",
          color: lt,
          background: r ? N : "transparent",
          marginLeft: 8
        },
        onClick: (p) => {
          p.stopPropagation(), i((h) => !h);
        },
        onMouseDown: (p) => p.stopPropagation(),
        children: [
          /* @__PURE__ */ d(ur, { text: `${Math.max(1, Math.trunc(t * 100))}%` }),
          /* @__PURE__ */ d(cr, { style: { transform: r ? "rotate(180deg)" : void 0 } })
        ]
      }
    ),
    r && yn(
      /* @__PURE__ */ d(
        "div",
        {
          ref: s,
          style: {
            position: "fixed",
            bottom: b.bottom,
            right: b.right,
            width: 180,
            background: _,
            border: `1px solid ${Jn}`,
            borderRadius: 8,
            padding: "4px 0",
            zIndex: 1e4
          },
          children: u.map((p) => /* @__PURE__ */ d(pr, { ...p, onClose: l }, p.label))
        }
      ),
      document.body
    )
  ] });
}
function Mt(t, e) {
  const n = Math.round(Math.max(0, t) * e), r = n % e, i = Math.floor(n / e), o = Math.floor(i / 60), s = i % 60;
  return { minutes: o, seconds: s, frames: r };
}
function ve(t, e) {
  const n = t.minutes * 60 + t.seconds + t.frames / e;
  return Math.round(n * e) / e;
}
function ye(t, e, n) {
  switch (t) {
    case "minutes":
      return Math.max(0, e);
    case "seconds":
      return Math.max(0, Math.min(59, e));
    case "frames":
      return Math.max(0, Math.min(n - 1, e));
  }
}
const be = ["minutes", "seconds", "frames"];
function hr(t) {
  return String(Math.floor(t)).padStart(2, "0");
}
function gr() {
  const t = C((w) => w.currentTime), e = C((w) => w.frameRate), n = C((w) => w.duration), r = C((w) => w.setCurrentTime), i = C((w) => w.isPlaying), o = C((w) => w.setPlaying), { onSeek: s } = V(), [f, a] = Q(!1), [c, l] = Q(() => Mt(t, e)), u = O(null), b = O([null, null, null]), m = Mt(t, e), p = f ? c : m, h = D(() => {
    const w = ve(c, e), y = Math.max(0, Math.min(w, n));
    r(y), s(y), a(!1);
  }, [c, e, n, r, s]), g = D(() => {
    l(Mt(t, e)), a(!1);
  }, [t, e]), v = D(() => {
    f || (l(Mt(t, e)), a(!0), i && o(!1));
  }, [f, t, e, i, o]), x = D(
    (w) => {
      const y = w.relatedTarget;
      u.current?.contains(y) || f && h();
    },
    [f, h]
  ), k = D(
    (w, y) => {
      const T = parseInt(y, 10);
      if (isNaN(T)) return;
      const L = ye(w, T, e);
      l((P) => ({ ...P, [w]: L }));
    },
    [e]
  ), S = (w, y) => {
    const T = be[w], L = y.currentTarget;
    switch (y.key) {
      case "ArrowUp":
      case "ArrowDown": {
        y.preventDefault();
        const P = y.key === "ArrowUp" ? 1 : -1, W = ye(T, c[T] + P, e), E = { ...c, [T]: W };
        l(E);
        const I = ve(E, e), A = Math.max(0, Math.min(I, n));
        r(A), s(A);
        break;
      }
      case "ArrowLeft": {
        L.selectionStart === 0 && L.selectionEnd === 0 && w > 0 && (y.preventDefault(), b.current[w - 1]?.focus());
        break;
      }
      case "ArrowRight": {
        const P = L.value.length;
        L.selectionStart === P && L.selectionEnd === P && w < 2 && (y.preventDefault(), b.current[w + 1]?.focus());
        break;
      }
      case "Enter":
        y.preventDefault(), h(), L.blur();
        break;
      case "Escape":
        y.preventDefault(), g(), L.blur();
        break;
    }
  };
  return z(() => {
    const w = b.current, y = (T) => T.target.select();
    return w.forEach((T) => T?.addEventListener("focus", y)), () => w.forEach((T) => T?.removeEventListener("focus", y));
  }, []), /* @__PURE__ */ d(
    "div",
    {
      className: "timecode-input",
      ref: u,
      onBlur: x,
      style: {
        display: "inline-flex",
        alignItems: "center",
        height: 24,
        fontSize: "0.75rem",
        border: `1px solid ${Qn}`,
        borderRadius: 4,
        padding: "0 8px",
        boxSizing: "border-box",
        transition: "border-color 0.15s"
      },
      children: be.map((w, y) => /* @__PURE__ */ M(q, { children: [
        y > 0 && /* @__PURE__ */ d(
          "span",
          {
            style: { position: "relative", top: "-1px", color: Tt, pointerEvents: "none", userSelect: "none" },
            children: ":"
          }
        ),
        /* @__PURE__ */ d(
          "input",
          {
            ref: (T) => {
              b.current[y] = T;
            },
            className: "timecode-segment",
            type: "text",
            inputMode: "numeric",
            value: hr(p[w]),
            onFocus: v,
            onChange: (T) => k(w, T.target.value),
            onKeyDown: (T) => S(y, T),
            "aria-label": w,
            style: {
              width: "2ch",
              background: "transparent",
              border: "none",
              outline: "none",
              color: Tt,
              textAlign: "center",
              padding: "1px 0",
              borderRadius: 2,
              caretColor: "transparent",
              font: "inherit"
            }
          }
        )
      ] }, w))
    }
  );
}
function Uo({
  isMuted: t = !1,
  onToggleMute: e,
  canvasMode: n,
  onCanvasModeChange: r,
  canvasZoom: i,
  onCanvasZoomChanged: o,
  onZoomToFit: s
}) {
  const f = C((v) => v.isPlaying), a = C((v) => v.currentTime <= 0), c = C((v) => v.currentTime >= v.duration), l = C((v) => v.setPlaying), u = C((v) => v.setCurrentTime), b = C((v) => v.tracks.length > 0), { store: m, onSeek: p } = V(), h = D(() => {
    b && l(!f);
  }, [f, l, b]), g = D(
    (v) => {
      if (!b) return;
      f && l(!1);
      const { currentTime: x, duration: k, frameRate: S } = m.getState(), w = Math.round(x * S), T = Math.max(0, Math.min(w + v, Math.round(k * S))) / S;
      u(T), p(T);
    },
    [f, l, u, b, m, p]
  );
  return Xn({ togglePlay: h, stepFrame: g }), /* @__PURE__ */ M(
    q,
    {
      className: "timeline-playback-controls",
      style: {
        height: "40px",
        padding: "0 8px",
        background: _,
        fontFamily: "'DM Sans', sans-serif"
      },
      children: [
        /* @__PURE__ */ d("div", { style: { flex: 1 } }),
        /* @__PURE__ */ M(ct, { style: { gap: 8 }, children: [
          /* @__PURE__ */ d(at, { onClick: () => g(-1), disabled: !b || a, ariaLabel: "Step back one frame", children: /* @__PURE__ */ d(me, { style: { transform: "scaleX(-1)" } }) }),
          /* @__PURE__ */ d(at, { onClick: h, disabled: !b, ariaLabel: f ? "Pause" : "Play", children: f ? /* @__PURE__ */ d(Yn, { width: 20, height: 20 }) : /* @__PURE__ */ d(Zn, { width: 20, height: 20 }) }),
          /* @__PURE__ */ d(at, { onClick: () => g(1), disabled: !b || c, ariaLabel: "Step forward one frame", children: /* @__PURE__ */ d(me, {}) }),
          /* @__PURE__ */ d(gr, {}),
          /* @__PURE__ */ d(he, {}),
          e && /* @__PURE__ */ d(nn, { onToggle: e, muted: t, disabled: !b })
        ] }),
        /* @__PURE__ */ M(q, { style: { flex: 1, justifyContent: "flex-end" }, children: [
          /* @__PURE__ */ d(q, { style: { gap: "4px", marginRight: "8px" }, children: /* @__PURE__ */ d(
            rr,
            {
              options: [
                { value: "select", icon: /* @__PURE__ */ d(or, { width: 20, height: 20 }), ariaLabel: "Select tool" },
                { value: "pan", icon: /* @__PURE__ */ d(ir, { width: 20, height: 20 }), ariaLabel: "Pan tool" }
              ],
              value: n,
              onChange: r,
              size: 24
            }
          ) }),
          /* @__PURE__ */ d(he, {}),
          /* @__PURE__ */ d(mr, { canvasZoom: i, onCanvasZoomChanged: o, onZoomToFit: s })
        ] })
      ]
    }
  );
}
function vr(t) {
  if (Array.isArray(t)) return t;
}
function yr(t, e) {
  var n = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n != null) {
    var r, i, o, s, f = [], a = !0, c = !1;
    try {
      if (o = (n = n.call(t)).next, e !== 0) for (; !(a = (r = o.call(n)).done) && (f.push(r.value), f.length !== e); a = !0) ;
    } catch (l) {
      c = !0, i = l;
    } finally {
      try {
        if (!a && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return f;
  }
}
function Xt(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function rn(t, e) {
  if (t) {
    if (typeof t == "string") return Xt(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Xt(t, e) : void 0;
  }
}
function br() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function on(t, e) {
  return vr(t) || yr(t, e) || rn(t, e) || br();
}
var Ft = {}, yt = {}, we;
function an() {
  if (we) return yt;
  we = 1, Object.defineProperty(yt, "__esModule", { value: !0 }), yt.bind = void 0;
  function t(e, n) {
    var r = n.type, i = n.listener, o = n.options;
    return e.addEventListener(r, i, o), function() {
      e.removeEventListener(r, i, o);
    };
  }
  return yt.bind = t, yt;
}
var et = {}, Se;
function wr() {
  if (Se) return et;
  Se = 1;
  var t = et && et.__assign || function() {
    return t = Object.assign || function(o) {
      for (var s, f = 1, a = arguments.length; f < a; f++) {
        s = arguments[f];
        for (var c in s) Object.prototype.hasOwnProperty.call(s, c) && (o[c] = s[c]);
      }
      return o;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(et, "__esModule", { value: !0 }), et.bindAll = void 0;
  var e = /* @__PURE__ */ an();
  function n(o) {
    if (!(typeof o > "u"))
      return typeof o == "boolean" ? {
        capture: o
      } : o;
  }
  function r(o, s) {
    if (s == null)
      return o;
    var f = t(t({}, o), { options: t(t({}, n(s)), n(o.options)) });
    return f;
  }
  function i(o, s, f) {
    var a = s.map(function(c) {
      var l = r(c, f);
      return (0, e.bind)(o, l);
    });
    return function() {
      a.forEach(function(l) {
        return l();
      });
    };
  }
  return et.bindAll = i, et;
}
var Te;
function Sr() {
  return Te || (Te = 1, (function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.bindAll = t.bind = void 0;
    var e = /* @__PURE__ */ an();
    Object.defineProperty(t, "bind", { enumerable: !0, get: function() {
      return e.bind;
    } });
    var n = /* @__PURE__ */ wr();
    Object.defineProperty(t, "bindAll", { enumerable: !0, get: function() {
      return n.bindAll;
    } });
  })(Ft)), Ft;
}
var dt = /* @__PURE__ */ Sr(), sn = "data-pdnd-honey-pot";
function cn(t) {
  return t instanceof Element && t.hasAttribute(sn);
}
function ln(t) {
  var e = document.elementsFromPoint(t.x, t.y), n = on(e, 2), r = n[0], i = n[1];
  return r ? cn(r) ? i ?? null : r : null;
}
function Ct(t) {
  "@babel/helpers - typeof";
  return Ct = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ct(t);
}
function Tr(t, e) {
  if (Ct(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(t, e);
    if (Ct(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function Cr(t) {
  var e = Tr(t, "string");
  return Ct(e) == "symbol" ? e : e + "";
}
function ee(t, e, n) {
  return (e = Cr(e)) in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var xr = 2147483647;
function Ce(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function xe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Ce(Object(n), !0).forEach(function(r) {
      ee(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Ce(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
var xt = 2, ke = xt / 2;
function kr(t) {
  return {
    x: Math.floor(t.x),
    y: Math.floor(t.y)
  };
}
function Lr(t) {
  return {
    x: t.x - ke,
    y: t.y - ke
  };
}
function Er(t) {
  return {
    x: Math.max(t.x, 0),
    y: Math.max(t.y, 0)
  };
}
function Mr(t) {
  return {
    x: Math.min(t.x, window.innerWidth - xt),
    y: Math.min(t.y, window.innerHeight - xt)
  };
}
function Le(t) {
  var e = t.client, n = Mr(Er(Lr(kr(e))));
  return DOMRect.fromRect({
    x: n.x,
    y: n.y,
    width: xt,
    height: xt
  });
}
function Ee(t) {
  var e = t.clientRect;
  return {
    left: "".concat(e.left, "px"),
    top: "".concat(e.top, "px"),
    width: "".concat(e.width, "px"),
    height: "".concat(e.height, "px")
  };
}
function Pr(t) {
  var e = t.client, n = t.clientRect;
  return (
    // is within horizontal bounds
    e.x >= n.x && e.x <= n.x + n.width && // is within vertical bounds
    e.y >= n.y && e.y <= n.y + n.height
  );
}
function Dr(t) {
  var e = t.initial, n = document.createElement("div");
  n.setAttribute(sn, "true");
  var r = Le({
    client: e
  });
  Object.assign(n.style, xe(xe({
    // Setting a background color explicitly to avoid any inherited styles.
    // Looks like this could be `opacity: 0`, but worried that _might_
    // cause the element to be ignored on some platforms.
    // When debugging, set backgroundColor to something like "red".
    backgroundColor: "transparent",
    position: "fixed",
    // Being explicit to avoid inheriting styles
    padding: 0,
    margin: 0,
    boxSizing: "border-box"
  }, Ee({
    clientRect: r
  })), {}, {
    // We want this element to absorb pointer events,
    // it's kind of the whole point 😉
    pointerEvents: "auto",
    // Want to make sure the honey pot is top of everything else.
    // Don't need to worry about native drag previews, as they will
    // have been rendered (and removed) before the honey pot is rendered
    zIndex: xr
  })), document.body.appendChild(n);
  var i = dt.bind(window, {
    type: "pointermove",
    listener: function(s) {
      var f = {
        x: s.clientX,
        y: s.clientY
      };
      r = Le({
        client: f
      }), Object.assign(n.style, Ee({
        clientRect: r
      }));
    },
    // using capture so we are less likely to be impacted by event stopping
    options: {
      capture: !0
    }
  });
  return function(s) {
    var f = s.current;
    if (i(), Pr({
      client: f,
      clientRect: r
    })) {
      n.remove();
      return;
    }
    function a() {
      c(), n.remove();
    }
    var c = dt.bindAll(window, [
      {
        type: "pointerdown",
        listener: a
      },
      {
        type: "pointermove",
        listener: a
      },
      {
        type: "focusin",
        listener: a
      },
      {
        type: "focusout",
        listener: a
      },
      // a 'pointerdown' should happen before 'dragstart', but just being super safe
      {
        type: "dragstart",
        listener: a
      },
      // if the user has dragged something out of the window
      // and then is dragging something back into the window
      // the first events we will see are "dragenter" (and then "dragover").
      // So if we see any of these we need to clear the post drag fix.
      {
        type: "dragenter",
        listener: a
      },
      {
        type: "dragover",
        listener: a
      }
      // Not adding a "wheel" event listener, as "wheel" by itself does not
      // resolve the bug.
    ], {
      // Using `capture` so less likely to be impacted by other code stopping events
      capture: !0
    });
  };
}
function Ir() {
  var t = null;
  function e() {
    return t = null, dt.bind(window, {
      type: "pointermove",
      listener: function(i) {
        t = {
          x: i.clientX,
          y: i.clientY
        };
      },
      // listening for pointer move in capture phase
      // so we are less likely to be impacted by events being stopped.
      options: {
        capture: !0
      }
    });
  }
  function n() {
    var r = null;
    return function(o) {
      var s = o.eventName, f = o.payload;
      if (s === "onDragStart") {
        var a = f.location.initial.input, c = t ?? {
          x: a.clientX,
          y: a.clientY
        };
        r = Dr({
          initial: c
        });
      }
      if (s === "onDrop") {
        var l, u = f.location.current.input;
        (l = r) === null || l === void 0 || l({
          current: {
            x: u.clientX,
            y: u.clientY
          }
        }), r = null, t = null;
      }
    };
  }
  return {
    bindEvents: e,
    getOnPostDispatch: n
  };
}
function Or(t) {
  if (Array.isArray(t)) return Xt(t);
}
function Ar(t) {
  if (typeof Symbol < "u" && t[Symbol.iterator] != null || t["@@iterator"] != null) return Array.from(t);
}
function Wr() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function un(t) {
  return Or(t) || Ar(t) || rn(t) || Wr();
}
function ft(t) {
  var e = null;
  return function() {
    if (!e) {
      for (var r = arguments.length, i = new Array(r), o = 0; o < r; o++)
        i[o] = arguments[o];
      var s = t.apply(this, i);
      e = {
        result: s
      };
    }
    return e.result;
  };
}
var Rr = ft(function() {
  return process.env.NODE_ENV === "test" ? !1 : navigator.userAgent.includes("Firefox");
}), ne = ft(function() {
  if (process.env.NODE_ENV === "test")
    return !1;
  var e = navigator, n = e.userAgent;
  return n.includes("AppleWebKit") && !n.includes("Chrome");
}), Zt = {
  isLeavingWindow: /* @__PURE__ */ Symbol("leaving"),
  isEnteringWindow: /* @__PURE__ */ Symbol("entering")
};
function jr(t) {
  var e = t.dragLeave;
  return ne() ? e.hasOwnProperty(Zt.isLeavingWindow) : !1;
}
(function() {
  if (typeof window > "u" || process.env.NODE_ENV === "test" || !ne())
    return;
  function e() {
    return {
      enterCount: 0,
      isOverWindow: !1
    };
  }
  var n = e();
  function r() {
    n = e();
  }
  dt.bindAll(
    window,
    [{
      type: "dragstart",
      listener: function() {
        n.enterCount = 0, n.isOverWindow = !0;
      }
    }, {
      type: "drop",
      listener: r
    }, {
      type: "dragend",
      listener: r
    }, {
      type: "dragenter",
      listener: function(o) {
        !n.isOverWindow && n.enterCount === 0 && (o[Zt.isEnteringWindow] = !0), n.isOverWindow = !0, n.enterCount++;
      }
    }, {
      type: "dragleave",
      listener: function(o) {
        n.enterCount--, n.isOverWindow && n.enterCount === 0 && (o[Zt.isLeavingWindow] = !0, n.isOverWindow = !1);
      }
    }],
    // using `capture: true` so that adding event listeners
    // in bubble phase will have the correct symbols
    {
      capture: !0
    }
  );
})();
function Hr(t) {
  return "nodeName" in t;
}
function Nr(t) {
  return Hr(t) && t.ownerDocument !== document;
}
function Fr(t) {
  var e = t.dragLeave, n = e.type, r = e.relatedTarget;
  return n !== "dragleave" ? !1 : ne() ? jr({
    dragLeave: e
  }) : r == null ? !0 : Rr() ? Nr(r) : r instanceof HTMLIFrameElement;
}
function Br(t) {
  var e = t.onDragEnd;
  return [
    // ## Detecting drag ending for removed draggables
    //
    // If a draggable element is removed during a drag and the user drops:
    // 1. if over a valid drop target: we get a "drop" event to know the drag is finished
    // 2. if not over a valid drop target (or cancelled): we get nothing
    // The "dragend" event will not fire on the source draggable if it has been
    // removed from the DOM.
    // So we need to figure out if a drag operation has finished by looking at other events
    // We can do this by looking at other events
    // ### First detection: "pointermove" events
    // 1. "pointermove" events cannot fire during a drag and drop operation
    // according to the spec. So if we get a "pointermove" it means that
    // the drag and drop operations has finished. So if we get a "pointermove"
    // we know that the drag is over
    // 2. 🦊😤 Drag and drop operations are _supposed_ to suppress
    // other pointer events. However, firefox will allow a few
    // pointer event to get through after a drag starts.
    // The most I've seen is 3
    {
      type: "pointermove",
      listener: /* @__PURE__ */ (function() {
        var n = 0;
        return function() {
          if (n < 20) {
            n++;
            return;
          }
          e();
        };
      })()
    },
    // ### Second detection: "pointerdown" events
    // If we receive this event then we know that a drag operation has finished
    // and potentially another one is about to start.
    // Note: `pointerdown` fires on all browsers / platforms before "dragstart"
    {
      type: "pointerdown",
      listener: e
    }
  ];
}
function wt(t) {
  return {
    altKey: t.altKey,
    button: t.button,
    buttons: t.buttons,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    shiftKey: t.shiftKey,
    clientX: t.clientX,
    clientY: t.clientY,
    pageX: t.pageX,
    pageY: t.pageY
  };
}
var zr = function(e) {
  var n = [], r = null, i = function() {
    for (var s = arguments.length, f = new Array(s), a = 0; a < s; a++)
      f[a] = arguments[a];
    n = f, !r && (r = requestAnimationFrame(function() {
      r = null, e.apply(void 0, n);
    }));
  };
  return i.cancel = function() {
    r && (cancelAnimationFrame(r), r = null);
  }, i;
}, Bt = zr(function(t) {
  return t();
}), Pt = /* @__PURE__ */ (function() {
  var t = null;
  function e(r) {
    var i = requestAnimationFrame(function() {
      t = null, r();
    });
    t = {
      frameId: i,
      fn: r
    };
  }
  function n() {
    t && (cancelAnimationFrame(t.frameId), t.fn(), t = null);
  }
  return {
    schedule: e,
    flush: n
  };
})();
function Vr(t) {
  var e = t.source, n = t.initial, r = t.dispatchEvent, i = {
    dropTargets: []
  };
  function o(f) {
    r(f), i = {
      dropTargets: f.payload.location.current.dropTargets
    };
  }
  var s = {
    start: function(a) {
      var c = a.nativeSetDragImage, l = {
        current: n,
        previous: i,
        initial: n
      };
      o({
        eventName: "onGenerateDragPreview",
        payload: {
          source: e,
          location: l,
          nativeSetDragImage: c
        }
      }), Pt.schedule(function() {
        o({
          eventName: "onDragStart",
          payload: {
            source: e,
            location: l
          }
        });
      });
    },
    dragUpdate: function(a) {
      var c = a.current;
      Pt.flush(), Bt.cancel(), o({
        eventName: "onDropTargetChange",
        payload: {
          source: e,
          location: {
            initial: n,
            previous: i,
            current: c
          }
        }
      });
    },
    drag: function(a) {
      var c = a.current;
      Bt(function() {
        Pt.flush();
        var l = {
          initial: n,
          previous: i,
          current: c
        };
        o({
          eventName: "onDrag",
          payload: {
            source: e,
            location: l
          }
        });
      });
    },
    drop: function(a) {
      var c = a.current, l = a.updatedSourcePayload;
      Pt.flush(), Bt.cancel(), o({
        eventName: "onDrop",
        payload: {
          source: l ?? e,
          location: {
            current: c,
            previous: i,
            initial: n
          }
        }
      });
    }
  };
  return s;
}
var Yt = {
  isActive: !1
};
function dn() {
  return !Yt.isActive;
}
function Kr(t) {
  return t.dataTransfer ? t.dataTransfer.setDragImage.bind(t.dataTransfer) : null;
}
function _r(t) {
  var e = t.current, n = t.next;
  if (e.length !== n.length)
    return !0;
  for (var r = 0; r < e.length; r++)
    if (e[r].element !== n[r].element)
      return !0;
  return !1;
}
function $r(t) {
  var e = t.event, n = t.dragType, r = t.getDropTargetsOver, i = t.dispatchEvent;
  if (!dn())
    return;
  var o = Xr({
    event: e,
    dragType: n,
    getDropTargetsOver: r
  });
  Yt.isActive = !0;
  var s = {
    current: o
  };
  zt({
    event: e,
    current: o.dropTargets
  });
  var f = Vr({
    source: n.payload,
    dispatchEvent: i,
    initial: o
  });
  function a(m) {
    var p = _r({
      current: s.current.dropTargets,
      next: m.dropTargets
    });
    s.current = m, p && f.dragUpdate({
      current: s.current
    });
  }
  function c(m) {
    var p = wt(m), h = cn(m.target) ? ln({
      x: p.clientX,
      y: p.clientY
    }) : m.target, g = r({
      target: h,
      input: p,
      source: n.payload,
      current: s.current.dropTargets
    });
    g.length && (m.preventDefault(), zt({
      event: m,
      current: g
    })), a({
      dropTargets: g,
      input: p
    });
  }
  function l() {
    s.current.dropTargets.length && a({
      dropTargets: [],
      input: s.current.input
    }), f.drop({
      current: s.current,
      updatedSourcePayload: null
    }), u();
  }
  function u() {
    Yt.isActive = !1, b();
  }
  var b = dt.bindAll(
    window,
    [{
      // 👋 Note: we are repurposing the `dragover` event as our `drag` event
      // this is because firefox does not publish pointer coordinates during
      // a `drag` event, but does for every other type of drag event
      // `dragover` fires on all elements that are being dragged over
      // Because we are binding to `window` - our `dragover` is effectively the same as a `drag`
      // 🦊😤
      type: "dragover",
      listener: function(p) {
        c(p), f.drag({
          current: s.current
        });
      }
    }, {
      type: "dragenter",
      listener: c
    }, {
      type: "dragleave",
      listener: function(p) {
        Fr({
          dragLeave: p
        }) && (a({
          input: s.current.input,
          dropTargets: []
        }), n.startedFrom === "external" && l());
      }
    }, {
      // A "drop" can only happen if the browser allowed the drop
      type: "drop",
      listener: function(p) {
        if (s.current = {
          dropTargets: s.current.dropTargets,
          input: wt(p)
        }, !s.current.dropTargets.length) {
          l();
          return;
        }
        p.preventDefault(), zt({
          event: p,
          current: s.current.dropTargets
        }), f.drop({
          current: s.current,
          // When dropping something native, we need to extract the latest
          // `.items` from the "drop" event as it is now accessible
          updatedSourcePayload: n.type === "external" ? n.getDropPayload(p) : null
        }), u();
      }
    }, {
      // "dragend" fires when on the drag source (eg a draggable element)
      // when the drag is finished.
      // "dragend" will fire after "drop" (if there was a successful drop)
      // "dragend" does not fire if the draggable source has been removed during the drag
      // or for external drag sources (eg files)
      // This "dragend" listener will not fire if there was a successful drop
      // as we will have already removed the event listener
      type: "dragend",
      listener: function(p) {
        s.current = {
          dropTargets: s.current.dropTargets,
          input: wt(p)
        }, l();
      }
    }].concat(un(Br({
      onDragEnd: l
    }))),
    // Once we have started a managed drag operation it is important that we see / own all drag events
    // We got one adoption bug pop up where some code was stopping (`event.stopPropagation()`)
    // all "drop" events in the bubble phase on the `document.body`.
    // This meant that we never saw the "drop" event.
    {
      capture: !0
    }
  );
  f.start({
    nativeSetDragImage: Kr(e)
  });
}
function zt(t) {
  var e, n = t.event, r = t.current, i = (e = r[0]) === null || e === void 0 ? void 0 : e.dropEffect;
  i != null && n.dataTransfer && (n.dataTransfer.dropEffect = i);
}
function Xr(t) {
  var e = t.event, n = t.dragType, r = t.getDropTargetsOver, i = wt(e);
  if (n.startedFrom === "external")
    return {
      input: i,
      dropTargets: []
    };
  var o = r({
    input: i,
    source: n.payload,
    target: e.target,
    current: []
  });
  return {
    input: i,
    dropTargets: o
  };
}
var Me = {
  canStart: dn,
  start: $r
}, Ut = /* @__PURE__ */ new Map();
function Zr(t) {
  var e = t.typeKey, n = t.mount, r = Ut.get(e);
  if (r)
    return r.usageCount++, r;
  var i = {
    typeKey: e,
    unmount: n(),
    usageCount: 1
  };
  return Ut.set(e, i), i;
}
function Yr(t) {
  var e = Zr(t);
  return function() {
    e.usageCount--, !(e.usageCount > 0) && (e.unmount(), Ut.delete(t.typeKey));
  };
}
function re() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return function() {
    e.forEach(function(i) {
      return i();
    });
  };
}
function fn(t, e) {
  var n = e.attribute, r = e.value;
  return t.setAttribute(n, r), function() {
    return t.removeAttribute(n);
  };
}
function Pe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Y(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Pe(Object(n), !0).forEach(function(r) {
      ee(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Pe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function Vt(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = Ur(t)) || e) {
      n && (t = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(c) {
        throw c;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, s = !0, f = !1;
  return { s: function() {
    n = n.call(t);
  }, n: function() {
    var c = n.next();
    return s = c.done, c;
  }, e: function(c) {
    f = !0, o = c;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (f) throw o;
    }
  } };
}
function Ur(t, e) {
  if (t) {
    if (typeof t == "string") return De(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? De(t, e) : void 0;
  }
}
function De(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Kt(t) {
  return t.slice(0).reverse();
}
function Gr(t) {
  var e = t.typeKey, n = t.defaultDropEffect, r = /* @__PURE__ */ new WeakMap(), i = "data-drop-target-for-".concat(e), o = "[".concat(i, "]");
  function s(m) {
    return r.set(m.element, m), function() {
      return r.delete(m.element);
    };
  }
  function f(m) {
    if (process.env.NODE_ENV !== "production") {
      var p = r.get(m.element);
      p && console.warn("You have already registered a [".concat(e, "] dropTarget on the same element"), {
        existing: p,
        proposed: m
      }), m.element instanceof HTMLIFrameElement && console.warn(`
            We recommend not registering <iframe> elements as drop targets
            as it can result in some strange browser event ordering.
          `.replace(/\s{2,}/g, " ").trim());
    }
    var h = re(fn(m.element, {
      attribute: i,
      value: "true"
    }), s(m));
    return ft(h);
  }
  function a(m) {
    var p, h, g, v, x = m.source, k = m.target, S = m.input, w = m.result, y = w === void 0 ? [] : w;
    if (k == null)
      return y;
    if (!(k instanceof Element))
      return k instanceof Node ? a({
        source: x,
        target: k.parentElement,
        input: S,
        result: y
      }) : y;
    var T = k.closest(o);
    if (T == null)
      return y;
    var L = r.get(T);
    if (L == null)
      return y;
    var P = {
      input: S,
      source: x,
      element: L.element
    };
    if (L.canDrop && !L.canDrop(P))
      return a({
        source: x,
        target: L.element.parentElement,
        input: S,
        result: y
      });
    var W = (p = (h = L.getData) === null || h === void 0 ? void 0 : h.call(L, P)) !== null && p !== void 0 ? p : {}, E = (g = (v = L.getDropEffect) === null || v === void 0 ? void 0 : v.call(L, P)) !== null && g !== void 0 ? g : n, I = {
      data: W,
      element: L.element,
      dropEffect: E,
      // we are collecting _actual_ drop targets, so these are
      // being applied _not_ due to stickiness
      isActiveDueToStickiness: !1
    };
    return a({
      source: x,
      target: L.element.parentElement,
      input: S,
      // Using bubble ordering. Same ordering as `event.getPath()`
      result: [].concat(un(y), [I])
    });
  }
  function c(m) {
    var p = m.eventName, h = m.payload, g = Vt(h.location.current.dropTargets), v;
    try {
      for (g.s(); !(v = g.n()).done; ) {
        var x, k = v.value, S = r.get(k.element), w = Y(Y({}, h), {}, {
          self: k
        });
        S == null || (x = S[p]) === null || x === void 0 || x.call(
          S,
          // I cannot seem to get the types right here.
          // TS doesn't seem to like that one event can need `nativeSetDragImage`
          // @ts-expect-error
          w
        );
      }
    } catch (y) {
      g.e(y);
    } finally {
      g.f();
    }
  }
  var l = {
    onGenerateDragPreview: c,
    onDrag: c,
    onDragStart: c,
    onDrop: c,
    onDropTargetChange: function(p) {
      var h = p.payload, g = new Set(h.location.current.dropTargets.map(function(B) {
        return B.element;
      })), v = /* @__PURE__ */ new Set(), x = Vt(h.location.previous.dropTargets), k;
      try {
        for (x.s(); !(k = x.n()).done; ) {
          var S, w = k.value;
          v.add(w.element);
          var y = r.get(w.element), T = g.has(w.element), L = Y(Y({}, h), {}, {
            self: w
          });
          if (y == null || (S = y.onDropTargetChange) === null || S === void 0 || S.call(y, L), !T) {
            var P;
            y == null || (P = y.onDragLeave) === null || P === void 0 || P.call(y, L);
          }
        }
      } catch (B) {
        x.e(B);
      } finally {
        x.f();
      }
      var W = Vt(h.location.current.dropTargets), E;
      try {
        for (W.s(); !(E = W.n()).done; ) {
          var I, A, F = E.value;
          if (!v.has(F.element)) {
            var H = Y(Y({}, h), {}, {
              self: F
            }), R = r.get(F.element);
            R == null || (I = R.onDropTargetChange) === null || I === void 0 || I.call(R, H), R == null || (A = R.onDragEnter) === null || A === void 0 || A.call(R, H);
          }
        }
      } catch (B) {
        W.e(B);
      } finally {
        W.f();
      }
    }
  };
  function u(m) {
    l[m.eventName](m);
  }
  function b(m) {
    var p = m.source, h = m.target, g = m.input, v = m.current, x = a({
      source: p,
      target: h,
      input: g
    });
    if (x.length >= v.length)
      return x;
    for (var k = Kt(v), S = Kt(x), w = [], y = 0; y < k.length; y++) {
      var T, L = k[y], P = S[y];
      if (P != null) {
        w.push(P);
        continue;
      }
      var W = w[y - 1], E = k[y - 1];
      if (W?.element !== E?.element)
        break;
      var I = r.get(L.element);
      if (!I)
        break;
      var A = {
        input: g,
        source: p,
        element: I.element
      };
      if (I.canDrop && !I.canDrop(A) || !((T = I.getIsSticky) !== null && T !== void 0 && T.call(I, A)))
        break;
      w.push(Y(Y({}, L), {}, {
        // making it clear to consumers this drop target is active due to stickiness
        isActiveDueToStickiness: !0
      }));
    }
    return Kt(w);
  }
  return {
    dropTargetForConsumers: f,
    getIsOver: b,
    dispatchEvent: u
  };
}
function qr(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (!n) {
    if (Array.isArray(t) || (n = Qr(t)) || e) {
      n && (t = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= t.length ? { done: !0 } : { done: !1, value: t[r++] };
      }, e: function(c) {
        throw c;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, s = !0, f = !1;
  return { s: function() {
    n = n.call(t);
  }, n: function() {
    var c = n.next();
    return s = c.done, c;
  }, e: function(c) {
    f = !0, o = c;
  }, f: function() {
    try {
      s || n.return == null || n.return();
    } finally {
      if (f) throw o;
    }
  } };
}
function Qr(t, e) {
  if (t) {
    if (typeof t == "string") return Ie(t, e);
    var n = {}.toString.call(t).slice(8, -1);
    return n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set" ? Array.from(t) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Ie(t, e) : void 0;
  }
}
function Ie(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, r = Array(e); n < e; n++) r[n] = t[n];
  return r;
}
function Oe(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Jr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Oe(Object(n), !0).forEach(function(r) {
      ee(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Oe(Object(n)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return t;
}
function to() {
  var t = /* @__PURE__ */ new Set(), e = null;
  function n(o) {
    e && (!o.canMonitor || o.canMonitor(e.canMonitorArgs)) && e.active.add(o);
  }
  function r(o) {
    var s = Jr({}, o);
    t.add(s), n(s);
    function f() {
      t.delete(s), e && e.active.delete(s);
    }
    return ft(f);
  }
  function i(o) {
    var s = o.eventName, f = o.payload;
    if (s === "onGenerateDragPreview") {
      e = {
        canMonitorArgs: {
          initial: f.location.initial,
          source: f.source
        },
        active: /* @__PURE__ */ new Set()
      };
      var a = qr(t), c;
      try {
        for (a.s(); !(c = a.n()).done; ) {
          var l = c.value;
          n(l);
        }
      } catch (g) {
        a.e(g);
      } finally {
        a.f();
      }
    }
    if (e) {
      for (var u = Array.from(e.active), b = 0, m = u; b < m.length; b++) {
        var p = m[b];
        if (e.active.has(p)) {
          var h;
          (h = p[s]) === null || h === void 0 || h.call(p, f);
        }
      }
      s === "onDrop" && (e.active.clear(), e = null);
    }
  }
  return {
    dispatchEvent: i,
    monitorForConsumers: r
  };
}
function eo(t) {
  var e = t.typeKey, n = t.mount, r = t.dispatchEventToSource, i = t.onPostDispatch, o = t.defaultDropEffect, s = to(), f = Gr({
    typeKey: e,
    defaultDropEffect: o
  });
  function a(u) {
    r?.(u), f.dispatchEvent(u), s.dispatchEvent(u), i?.(u);
  }
  function c(u) {
    var b = u.event, m = u.dragType;
    Me.start({
      event: b,
      dragType: m,
      getDropTargetsOver: f.getIsOver,
      dispatchEvent: a
    });
  }
  function l() {
    function u() {
      var b = {
        canStart: Me.canStart,
        start: c
      };
      return n(b);
    }
    return Yr({
      typeKey: e,
      mount: u
    });
  }
  return {
    registerUsage: l,
    dropTarget: f.dropTargetForConsumers,
    monitor: s.monitorForConsumers
  };
}
var no = ft(function() {
  return navigator.userAgent.toLocaleLowerCase().includes("android");
}), ro = "pdnd:android-fallback", Ae = "text/plain", oo = "text/uri-list", io = "application/vnd.pdnd", kt = /* @__PURE__ */ new WeakMap();
function ao(t) {
  return kt.set(t.element, t), function() {
    kt.delete(t.element);
  };
}
var We = Ir(), oe = eo({
  typeKey: "element",
  defaultDropEffect: "move",
  mount: function(e) {
    return re(We.bindEvents(), dt.bind(document, {
      type: "dragstart",
      listener: function(r) {
        var i, o, s, f, a, c;
        if (e.canStart(r) && !r.defaultPrevented) {
          if (!r.dataTransfer) {
            process.env.NODE_ENV !== "production" && console.warn(`
              It appears as though you have are not testing DragEvents correctly.

              - If you are unit testing, ensure you have polyfilled DragEvent.
              - If you are browser testing, ensure you are dispatching drag events correctly.

              Please see our testing guides for more information:
              https://atlassian.design/components/pragmatic-drag-and-drop/core-package/testing
            `.replace(/ {2}/g, ""));
            return;
          }
          var l = r.target;
          if (l instanceof HTMLElement) {
            var u = kt.get(l);
            if (u) {
              var b = wt(r), m = {
                element: u.element,
                dragHandle: (i = u.dragHandle) !== null && i !== void 0 ? i : null,
                input: b
              };
              if (u.canDrag && !u.canDrag(m)) {
                r.preventDefault();
                return;
              }
              if (u.dragHandle) {
                var p = ln({
                  x: b.clientX,
                  y: b.clientY
                });
                if (!u.dragHandle.contains(p)) {
                  r.preventDefault();
                  return;
                }
              }
              var h = (o = (s = u.getInitialDataForExternal) === null || s === void 0 ? void 0 : s.call(u, m)) !== null && o !== void 0 ? o : null;
              if (h)
                for (var g = 0, v = Object.entries(h); g < v.length; g++) {
                  var x = on(v[g], 2), k = x[0], S = x[1];
                  r.dataTransfer.setData(k, S ?? "");
                }
              no() && !r.dataTransfer.types.includes(Ae) && !r.dataTransfer.types.includes(oo) && r.dataTransfer.setData(Ae, ro), r.dataTransfer.setData(io, "");
              var w = {
                element: u.element,
                dragHandle: (f = u.dragHandle) !== null && f !== void 0 ? f : null,
                data: (a = (c = u.getInitialData) === null || c === void 0 ? void 0 : c.call(u, m)) !== null && a !== void 0 ? a : {}
              }, y = {
                type: "element",
                payload: w,
                startedFrom: "internal"
              };
              e.start({
                event: r,
                dragType: y
              });
            }
          }
        }
      }
    }));
  },
  dispatchEventToSource: function(e) {
    var n, r, i = e.eventName, o = e.payload;
    (n = kt.get(o.source.element)) === null || n === void 0 || (r = n[i]) === null || r === void 0 || r.call(
      n,
      // I cannot seem to get the types right here.
      // TS doesn't seem to like that one event can need `nativeSetDragImage`
      // @ts-expect-error
      o
    );
  },
  onPostDispatch: We.getOnPostDispatch()
}), so = oe.dropTarget, co = oe.monitor;
function lo(t) {
  if (process.env.NODE_ENV !== "production" && t.dragHandle && !t.element.contains(t.dragHandle) && console.warn("Drag handle element must be contained in draggable element", {
    element: t.element,
    dragHandle: t.dragHandle
  }), process.env.NODE_ENV !== "production") {
    var e = kt.get(t.element);
    e && console.warn("You have already registered a `draggable` on the same element", {
      existing: e,
      proposed: t
    });
  }
  var n = re(
    // making the draggable register the adapter rather than drop targets
    // this is because you *must* have a draggable element to start a drag
    // but you _might_ not have any drop targets immediately
    // (You might create drop targets async)
    oe.registerUsage(),
    ao(t),
    fn(t.element, {
      attribute: "draggable",
      value: "true"
    })
  );
  return ft(n);
}
function uo(t) {
  const { store: e } = V(), n = C((o) => o.setZoomLevel), r = C((o) => o.setScrollPosition), i = D(
    (o) => {
      if (!o.ctrlKey && !o.metaKey) return;
      o.preventDefault();
      const s = e.getState(), f = Je(s), { currentTime: a, duration: c, zoomLevel: l, scrollPosition: u } = s;
      if (c === 0) return;
      const m = Math.pow(2, -o.deltaY * 5e-3), p = l * m, h = Math.max(it, Math.min(p, f));
      if (h === l) return;
      const g = t.current;
      if (!g) return;
      const v = h / l, { newScroll: x } = Ze(
        l,
        v,
        a,
        u,
        c,
        g.getBoundingClientRect().width
      );
      n(h), r(x);
    },
    [t, n, r, e]
  );
  z(() => {
    const o = t.current;
    if (o)
      return o.addEventListener("wheel", i, { passive: !1 }), () => {
        o.removeEventListener("wheel", i);
      };
  }, [t, i]);
}
function fo(t) {
  const { store: e } = V(), n = D(
    (c) => {
      if (c.ctrlKey || c.metaKey || !c.shiftKey && Math.abs(c.deltaX) <= 0)
        return;
      const l = Math.abs(c.deltaX) > 0 ? c.deltaX : c.deltaY;
      c.preventDefault();
      const { scrollPosition: u, duration: b, setScrollPosition: m } = e.getState(), p = $(e.getState()), h = St(e.getState()), g = l / p, v = u + g, x = st(b, h, p);
      m(Math.max(0, Math.min(v, x)));
    },
    [e]
  ), r = O(!1), i = O(0), o = O(0), s = D(
    (c) => {
      c.button === 1 && (c.preventDefault(), r.current = !0, i.current = c.clientX, o.current = e.getState().scrollPosition, document.body.style.cursor = "grabbing");
    },
    [e]
  ), f = D(
    (c) => {
      if (!r.current) return;
      const l = i.current - c.clientX, { duration: u, setScrollPosition: b } = e.getState(), m = $(e.getState()), p = St(e.getState()), h = l / m, g = o.current + h, v = st(u, p, m);
      b(Math.max(0, Math.min(g, v)));
    },
    [e]
  ), a = D(() => {
    r.current && (r.current = !1, document.body.style.cursor = "");
  }, []);
  z(() => {
    const c = t.current;
    if (c)
      return c.addEventListener("wheel", n, { passive: !1 }), c.addEventListener("mousedown", s), document.addEventListener("mousemove", f), document.addEventListener("mouseup", a), () => {
        c.removeEventListener("wheel", n), c.removeEventListener("mousedown", s), document.removeEventListener("mousemove", f), document.removeEventListener("mouseup", a);
      };
  }, [t, n, s, f, a]);
}
function po(t, e) {
  z(() => {
    const n = t.current, r = e.current;
    if (!n || !r) return;
    const i = () => {
      r.scrollTop = n.scrollTop;
    }, o = (s) => {
      n.scrollTop += s.deltaY, s.preventDefault();
    };
    return n.addEventListener("scroll", i), r.addEventListener("wheel", o, { passive: !1 }), () => {
      n.removeEventListener("scroll", i), r.removeEventListener("wheel", o);
    };
  }, [t, e]);
}
function mo(t, e, n, r, i) {
  const o = Math.round(t * i) / i;
  let s = o, f = r, a = null;
  for (const c of n) {
    const l = Math.abs(o - c);
    l < f && (f = l, s = c, a = c);
    const u = Math.abs(o + e - c);
    u < f && (f = u, s = c - e, a = c);
  }
  return { startTime: s, snapIndicator: a };
}
function ho(t, e, n, r, i, o, s, f) {
  const a = 1 / f;
  let c = e + t, l = i;
  if (n === "video" && (l = i - t, l < 0 && (c = e + i, l = 0)), c < a) {
    const h = a - c;
    c = a, n === "video" && (l += h);
  }
  const u = r + c, { snappedEdge: b, snapIndicator: m } = ie(u, o, s), p = b - u;
  return p !== 0 && (c += p, n === "video" && (l -= p), n === "video" && l < 0 && (c += l, l = 0), c < a && (n === "video" && (l += a - c), c = a)), c = Math.round(c * f) / f, n === "video" && (l = e + i - c), { duration: c, trimEnd: l, snapIndicator: m };
}
function go(t, e, n, r, i, o, s, f) {
  const a = 1 / f;
  let c = r + t, l = e - t, u = i;
  if (n === "video" && (u = i + t, u < 0 && (c = r - i, l = e + i, u = 0)), c < 0) {
    const g = -c;
    c = 0, l -= g, n === "video" && (u += g);
  }
  if (l < a) {
    const g = a - l;
    l = a, c -= g, n === "video" && (u -= g), c < 0 && (c = 0), n === "video" && u < 0 && (u = 0);
  }
  const b = c, { snappedEdge: m, snapIndicator: p } = ie(b, o, s), h = m - b;
  if (h !== 0 && (c += h, l -= h, n === "video" && (u += h), n === "video" && u < 0 && (c -= u, l += u, u = 0), c < 0 && (l += c, n === "video" && (u -= c), c = 0), l < a)) {
    const g = a - l;
    l = a, c -= g, n === "video" && (u -= g), c < 0 && (c = 0), n === "video" && u < 0 && (u = 0);
  }
  return c = Math.round(c * f) / f, l = r + e - c, n === "video" && (u = i + e - l), { startTime: c, duration: l, trimStart: u, snapIndicator: p };
}
function vo(t, e, n, r) {
  const i = [n, 0, r];
  for (const o of t)
    o.id !== e && i.push(o.startTime, o.startTime + o.duration);
  return i;
}
function ie(t, e, n) {
  let r = t, i = n, o = null;
  for (const s of e) {
    const f = Math.abs(t - s);
    f < i && (i = f, r = s, o = s);
  }
  return { snappedEdge: r, snapIndicator: o };
}
const yo = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d("path", { d: "M12 5.25V18.75", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M5.25 8.25V5.25H18.75V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d("path", { d: "M9 18.75H15", stroke: "currentColor", strokeWidth: "1.125", strokeLinecap: "round", strokeLinejoin: "round" })
] }), bo = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M19.5 3.75H4.5C4.08579 3.75 3.75 4.08579 3.75 4.5V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V4.5C20.25 4.08579 19.9142 3.75 19.5 3.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M9 10.5C9.82843 10.5 10.5 9.82843 10.5 9C10.5 8.17157 9.82843 7.5 9 7.5C8.17157 7.5 7.5 8.17157 7.5 9C7.5 9.82843 8.17157 10.5 9 10.5Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M5.31494 20.2499L15.5946 9.96923C15.6643 9.8995 15.747 9.84418 15.838 9.80644C15.9291 9.76869 16.0267 9.74927 16.1253 9.74927C16.2238 9.74927 16.3214 9.76869 16.4125 9.80644C16.5035 9.84418 16.5862 9.8995 16.6559 9.96923L20.2503 13.5645",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), wo = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M14.8 12.5L10 9.5V15.5L14.8 12.5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M20.1818 5H3.81818C3.36631 5 3 5.47969 3 6.07143V18.9286C3 19.5203 3.36631 20 3.81818 20H20.1818C20.6337 20 21 19.5203 21 18.9286V6.07143C21 5.47969 20.6337 5 20.1818 5Z",
      stroke: "currentColor",
      strokeWidth: "1.13",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), So = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 5.25C4.5 5.25 1.5 12 1.5 12C1.5 12 4.5 18.75 12 18.75C19.5 18.75 22.5 12 22.5 12C22.5 12 19.5 5.25 12 5.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92893 14.0711 8.25 12 8.25C9.92893 8.25 8.25 9.92893 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), To = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M3 9.75C4.57594 11.7009 7.46531 14.25 12 14.25C16.5347 14.25 19.4241 11.7009 21 9.75",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M21 15.7499L18.8081 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M15.0001 17.9998L14.3354 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M9 17.9998L9.66469 14.0107",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M3 15.7499L5.19187 11.9146",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Co = ({
  onToggle: t,
  hidden: e,
  disabled: n
}) => /* @__PURE__ */ d(at, { size: 20, disabled: n, onClick: t, stopPropagation: !0, children: e ? /* @__PURE__ */ d(To, { width: 14, height: 14 }) : /* @__PURE__ */ d(So, { width: 14, height: 14 }) }), xo = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C12.9946 1.5 13.9484 1.89509 14.6517 2.59835C15.3549 3.30161 15.75 4.25544 15.75 5.25V8.25",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), ko = ({ title: t, ...e }) => /* @__PURE__ */ M("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", ...e, children: [
  t ? /* @__PURE__ */ d("title", { children: t }) : null,
  /* @__PURE__ */ d(
    "path",
    {
      d: "M19.5 8.25H4.5C4.08579 8.25 3.75 8.58579 3.75 9V19.5C3.75 19.9142 4.08579 20.25 4.5 20.25H19.5C19.9142 20.25 20.25 19.9142 20.25 19.5V9C20.25 8.58579 19.9142 8.25 19.5 8.25Z",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ d(
    "path",
    {
      d: "M8.25 8.25V5.25C8.25 4.25544 8.64509 3.30161 9.34835 2.59835C10.0516 1.89509 11.0054 1.5 12 1.5C13.8141 1.5 15.4022 2.78812 15.75 4.5",
      stroke: "currentColor",
      strokeWidth: "1.125",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] }), Lo = ({
  onToggle: t,
  locked: e,
  disabled: n
}) => /* @__PURE__ */ d(at, { size: 20, disabled: n, onClick: t, stopPropagation: !0, children: e ? /* @__PURE__ */ d(xo, { width: 14, height: 14 }) : /* @__PURE__ */ d(ko, { width: 14, height: 14 }) });
function Eo() {
  const t = C((h) => h.zoomLevel), e = C(Je), n = C((h) => h.setZoomLevel), r = C((h) => h.scrollPosition), i = C((h) => h.currentTime), o = C((h) => h.duration), s = C((h) => h.containerWidth), f = C((h) => h.setScrollPosition), a = (h) => {
    const g = h / t, { newScroll: v } = Ze(t, g, i, r, o, s);
    n(h), f(v);
  }, c = () => {
    a(Math.min(t * pe, e));
  }, l = () => {
    a(Math.max(t / pe, it));
  }, u = Math.log(it), b = Math.log(Math.max(e, it + _n)), m = (Math.log(t) - u) / (b - u), p = (h) => {
    const g = parseFloat(h.target.value), v = Math.exp(u + g * (b - u));
    a(v);
  };
  return /* @__PURE__ */ M(q, { style: { gap: 4, height: "100%", paddingRight: "8px" }, onMouseDown: (h) => h.stopPropagation(), children: [
    /* @__PURE__ */ d(
      ct,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: Tt,
          cursor: "pointer"
        },
        onClick: l,
        disabled: t <= it,
        "aria-label": "Zoom out",
        children: /* @__PURE__ */ M("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ d("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ d("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    ),
    /* @__PURE__ */ d(
      "input",
      {
        className: "zoom-slider",
        type: "range",
        min: "0",
        max: "1",
        step: "0.001",
        value: m,
        onChange: p,
        "aria-label": "Zoom level",
        style: {
          WebkitAppearance: "none",
          appearance: "none",
          flex: 1,
          minWidth: 0,
          height: 6,
          borderRadius: 3,
          background: N,
          outline: "none",
          cursor: "pointer"
        }
      }
    ),
    /* @__PURE__ */ d(
      ct,
      {
        component: "button",
        className: "zoom-button",
        style: {
          width: 12,
          height: 12,
          flexShrink: 0,
          padding: 0,
          border: "none",
          borderRadius: "50%",
          background: "transparent",
          color: Tt,
          cursor: "pointer"
        },
        onClick: c,
        disabled: t >= e,
        "aria-label": "Zoom in",
        children: /* @__PURE__ */ M("svg", { viewBox: "0 0 12 12", width: "12", height: "12", children: [
          /* @__PURE__ */ d("circle", { cx: "6", cy: "6", r: "5", fill: "none", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ d("line", { x1: "3.5", y1: "6", x2: "8.5", y2: "6", stroke: "currentColor", strokeWidth: "1.2" }),
          /* @__PURE__ */ d("line", { x1: "6", y1: "3.5", x2: "6", y2: "8.5", stroke: "currentColor", strokeWidth: "1.2" })
        ] })
      }
    )
  ] });
}
const Mo = 4, Re = qe * 2 + Ge + Mo;
function Po() {
  const t = C((v) => v.scrollPosition), e = C((v) => v.duration), n = C((v) => v.containerWidth), r = C(St), i = C($), o = C((v) => v.setScrollPosition), { store: s } = V(), f = O(null), a = Math.max(0, n - Re), c = e > 0 ? r / e : 1, l = Math.max(fe, a * c), u = st(e, r, i), b = u > 0 ? t / u * (a - l) : 0, m = O({ active: !1, startMouseX: 0, startThumbLeft: 0 }), p = O(null);
  if (z(() => {
    const v = (k) => {
      if (!m.current.active) return;
      const S = s.getState(), { duration: w, containerWidth: y, setScrollPosition: T } = S, L = St(S), P = $(S), W = Math.max(0, y - Re), E = w > 0 ? L / w : 1, I = Math.max(fe, W * E), A = st(w, L, P), F = k.clientX - m.current.startMouseX, H = W - I;
      if (H <= 0) return;
      const B = Math.max(0, Math.min(m.current.startThumbLeft + F, H)) / H;
      T(B * A);
    }, x = () => {
      m.current.active && (m.current.active = !1, document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", x));
    };
    p.current = { onMouseMove: v, onMouseUp: x };
  }, [s]), r >= e) return null;
  function h(v) {
    if (v.button !== 0) return;
    v.stopPropagation();
    const x = p.current;
    x && (m.current = {
      active: !0,
      startMouseX: v.clientX,
      startThumbLeft: b
    }, document.addEventListener("mousemove", x.onMouseMove), document.addEventListener("mouseup", x.onMouseUp));
  }
  function g(v) {
    const x = f.current;
    if (!x) return;
    const k = x.getBoundingClientRect(), S = v.clientX - k.left, w = a - l;
    if (w <= 0) return;
    const T = Math.max(0, Math.min(S - l / 2, w)) / w;
    o(T * u);
  }
  return /* @__PURE__ */ d(
    "div",
    {
      ref: f,
      className: "timeline-scrollbar",
      style: {
        position: "relative",
        flex: 1,
        minWidth: 0,
        height: 6,
        margin: "auto 4px auto 0",
        background: N,
        borderRadius: 3,
        cursor: "pointer"
      },
      onMouseDown: g,
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            position: "absolute",
            top: 0,
            height: "100%",
            borderRadius: 3,
            background: ut,
            cursor: "grab",
            transition: "background 0.15s",
            width: l,
            left: b
          },
          onMouseDown: h
        }
      )
    }
  );
}
function Do(t) {
  return t.type === "video" ? { background: nr } : t.type === "text" ? { background: er } : {
    background: `url(${t.thumbnailUrl})`,
    backgroundSize: "32px 32px",
    backgroundRepeat: "repeat"
  };
}
function _t(t, e) {
  const n = e.getBoundingClientRect();
  return t - n.left < ue ? "trim-left" : n.right - t < ue ? "trim-right" : "move";
}
function Io({ track: t, isSelected: e }) {
  const n = C((E) => E.scrollPosition), r = C((E) => E.containerWidth), i = C($), o = C((E) => E.setTrackTrim), { store: s, onTrackStartTimeChange: f, onTrackTrimChange: a, onTrackSelect: c } = V(), l = O({
    active: !1,
    mode: "move",
    trackId: -1,
    trackType: "image",
    trackDuration: 0,
    initialStartTime: 0,
    initialTrimStart: 0,
    initialTrimEnd: 0,
    mouseDownClientX: 0,
    lastSnappedStartTime: 0,
    // For trim: track last-applied values to avoid duplicate updates
    lastDuration: 0,
    lastTrimStart: 0,
    lastTrimEnd: 0
  }), u = D(
    (E) => {
      if (E.button !== 0 || (E.stopPropagation(), t.locked)) return;
      c(t.id);
      const I = E.currentTarget, A = _t(E.clientX, I);
      l.current = {
        active: !0,
        mode: A,
        trackId: t.id,
        trackType: t.type,
        trackDuration: t.duration,
        initialStartTime: t.startTime,
        initialTrimStart: t.trimStart ?? 0,
        initialTrimEnd: t.trimEnd ?? 0,
        mouseDownClientX: E.clientX,
        lastSnappedStartTime: t.startTime,
        lastDuration: t.duration,
        lastTrimStart: t.trimStart ?? 0,
        lastTrimEnd: t.trimEnd ?? 0
      };
      const { setDraggingTrackId: F } = s.getState();
      F(t.id), A === "move" ? document.body.classList.add("timeline-dragging") : document.body.classList.add("timeline-trimming");
      const H = (B) => {
        if (!l.current.active) return;
        const J = s.getState(), { frameRate: rt, setTrackStartTime: pt, setTrackTrim: mt, setSnapIndicatorTime: ht } = J, ot = $(J), Lt = B.clientX - l.current.mouseDownClientX, tt = ot > 0 ? Lt / ot : 0, It = (B.shiftKey ? Ue : Ye) / ot, { tracks: pn, currentTime: mn, duration: hn } = s.getState(), Ot = vo(pn, l.current.trackId, mn, hn), { mode: At, trackType: Et, initialStartTime: gt, initialTrimStart: ae, initialTrimEnd: se, trackDuration: Wt } = l.current;
        if (At === "move") {
          const j = gt + tt, K = mo(j, Wt, Ot, It, rt);
          if (ht(K.snapIndicator), K.startTime === l.current.lastSnappedStartTime) return;
          l.current.lastSnappedStartTime = K.startTime, pt(l.current.trackId, K.startTime), f(l.current.trackId, K.startTime, !0);
        } else if (At === "trim-right") {
          const j = ho(
            tt,
            Wt,
            Et,
            gt,
            se,
            Ot,
            It,
            rt
          );
          if (ht(j.snapIndicator), j.duration === l.current.lastDuration && j.trimEnd === l.current.lastTrimEnd)
            return;
          l.current.lastDuration = j.duration, l.current.lastTrimEnd = j.trimEnd, l.current.lastSnappedStartTime = gt;
          const K = {
            startTime: gt,
            duration: j.duration,
            ...Et === "video" ? { trimStart: ae, trimEnd: j.trimEnd } : {}
          };
          mt(l.current.trackId, K), a(l.current.trackId, K, !0);
        } else if (At === "trim-left") {
          const j = go(
            tt,
            Wt,
            Et,
            gt,
            ae,
            Ot,
            It,
            rt
          );
          if (ht(j.snapIndicator), j.startTime === l.current.lastSnappedStartTime && j.duration === l.current.lastDuration && j.trimStart === l.current.lastTrimStart)
            return;
          l.current.lastSnappedStartTime = j.startTime, l.current.lastDuration = j.duration, l.current.lastTrimStart = j.trimStart;
          const K = {
            startTime: j.startTime,
            duration: j.duration,
            ...Et === "video" ? { trimStart: j.trimStart, trimEnd: se } : {}
          };
          mt(l.current.trackId, K), a(l.current.trackId, K, !0);
        }
      }, R = () => {
        if (!l.current.active) return;
        const { mode: B } = l.current;
        l.current.active = !1, document.body.classList.remove("timeline-dragging"), document.body.classList.remove("timeline-trimming");
        const { setSnapIndicatorTime: J, setDraggingTrackId: rt } = s.getState();
        if (J(null), rt(null), B === "move")
          f(l.current.trackId, l.current.lastSnappedStartTime, !1);
        else {
          const pt = {
            startTime: l.current.lastSnappedStartTime,
            duration: l.current.lastDuration,
            ...l.current.trackType === "video" ? { trimStart: l.current.lastTrimStart, trimEnd: l.current.lastTrimEnd } : {}
          };
          a(l.current.trackId, pt, !1);
        }
        document.removeEventListener("mousemove", H), document.removeEventListener("mouseup", R);
      };
      document.addEventListener("mousemove", H), document.addEventListener("mouseup", R);
    },
    [t, c, f, a, s]
  ), b = D(
    (E) => {
      if (t.locked) return;
      const I = E.currentTarget, A = _t(E.clientX, I), F = t.trimStart ?? 0, H = t.trimEnd ?? 0;
      let R = null;
      A === "trim-left" && F > 0 ? R = {
        startTime: t.startTime - F,
        duration: t.duration + F,
        trimStart: 0,
        trimEnd: H
      } : A === "trim-right" && H > 0 && (R = {
        startTime: t.startTime,
        duration: t.duration + H,
        trimStart: F,
        trimEnd: 0
      }), R && (o(t.id, R), a(t.id, R, !1));
    },
    [t, o, a]
  ), m = D(
    (E) => {
      if (t.locked || l.current.active) return;
      const I = E.currentTarget, A = _t(E.clientX, I);
      I.style.cursor = A === "move" ? "grab" : "ew-resize";
    },
    [t.locked]
  ), p = D(
    (E) => {
      if (l.current.active) return;
      const I = E.currentTarget;
      I.style.cursor = t.locked ? "not-allowed" : "grab";
    },
    [t.locked]
  ), h = (t.startTime - n) * i, g = h + t.duration * i, v = Math.max(0, h), x = Math.max(0, Math.min(g, r) - v), k = Do(t), S = v - h, w = t.trimStart ?? 0, y = t.trimEnd ?? 0, T = w * i, L = h - T, P = g, W = y * i;
  return /* @__PURE__ */ M(
    "div",
    {
      "data-track-id": t.id,
      style: {
        position: "relative",
        height: te,
        background: _,
        borderBottom: `1px solid ${N}`,
        boxSizing: "border-box"
      },
      children: [
        w > 0 && /* @__PURE__ */ d(
          "div",
          {
            style: {
              position: "absolute",
              height: Ht,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `${vt}px 0 0 ${vt}px`,
              pointerEvents: "none",
              left: Math.max(0, L),
              width: Math.max(0, Math.min(L + T, r) - Math.max(0, L)),
              background: k.background,
              backgroundSize: k.backgroundSize,
              backgroundRepeat: k.backgroundRepeat,
              opacity: de
            }
          }
        ),
        t.duration > 0 && /* @__PURE__ */ d(
          "div",
          {
            className: `timeline-track-clip${e ? " selected" : ""}`,
            style: {
              position: "absolute",
              height: Ht,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: vt,
              overflow: "hidden",
              cursor: t.locked ? "not-allowed" : "grab",
              left: v,
              width: x,
              background: k.background,
              backgroundSize: k.backgroundSize,
              backgroundRepeat: k.backgroundRepeat,
              backgroundPosition: S > 0 ? `${-S}px 0` : void 0,
              opacity: t.hidden ? 0.5 : void 0
            },
            onMouseDown: u,
            onDoubleClick: b,
            onMouseMove: m,
            onMouseLeave: p,
            children: t.label && /* @__PURE__ */ d(
              q,
              {
                component: "span",
                style: {
                  height: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  pointerEvents: "none",
                  userSelect: "none",
                  ...t.type === "text" ? { alignItems: "flex-start", padding: "4px 8px 0", color: qn } : { padding: "0 6px", color: _ },
                  ...S > 0 ? { marginLeft: -S } : void 0
                },
                children: t.type === "text" && /* @__PURE__ */ d(fr, { text: t.label })
              }
            )
          }
        ),
        y > 0 && /* @__PURE__ */ d(
          "div",
          {
            style: {
              position: "absolute",
              height: Ht,
              top: "50%",
              transform: "translateY(-50%)",
              borderRadius: `0 ${vt}px ${vt}px 0`,
              pointerEvents: "none",
              left: Math.max(0, P),
              width: Math.max(0, Math.min(P + W, r) - Math.max(0, P)),
              background: k.background,
              backgroundSize: k.backgroundSize,
              backgroundRepeat: k.backgroundRepeat,
              opacity: de
            }
          }
        )
      ]
    }
  );
}
function Oo() {
  const t = C((o) => o.snapIndicatorTime), e = C((o) => o.scrollPosition), n = C($), r = C((o) => o.containerWidth);
  if (t === null) return null;
  const i = (t - e) * n;
  return i < -1 || i > r + 1 ? null : /* @__PURE__ */ d(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 9,
        transform: `translateX(${i}px)`
      },
      children: /* @__PURE__ */ d(
        "div",
        {
          style: {
            position: "absolute",
            top: U,
            left: 0,
            width: 1,
            bottom: 0,
            background: lt
          }
        }
      )
    }
  );
}
const Ao = 15, je = U - Ao;
function Wo() {
  const t = C((s) => s.currentTime), e = C((s) => s.scrollPosition), n = C($), r = (t - e) * n, i = C((s) => s.duration), o = C((s) => s.containerWidth);
  return i === 0 || r < -10 || r > o + 10 ? null : /* @__PURE__ */ M(
    "div",
    {
      style: {
        position: "absolute",
        top: 0,
        left: 0,
        width: 0,
        bottom: 0,
        pointerEvents: "none",
        zIndex: 10,
        transform: `translateX(${r}px)`
      },
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            style: {
              position: "absolute",
              top: je,
              left: -6,
              width: 12,
              height: 8,
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: `8px solid ${lt}`,
              pointerEvents: "auto"
            }
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            style: {
              position: "absolute",
              top: je,
              left: -1,
              width: 1,
              bottom: 0,
              background: lt
            }
          }
        )
      ]
    }
  );
}
function Ro() {
  const t = C((a) => a.duration), e = C((a) => a.frameRate), n = C((a) => a.scrollPosition), r = C((a) => a.containerWidth), i = C(St), o = C($), { ticks: s, majorInterval: f } = $t(() => {
    if (t === 0 || r === 0) return { ticks: [], majorInterval: 0 };
    const { start: a, end: c } = Rn(n, i, t), { interval: l, majorInterval: u } = Fn(o, e);
    return {
      ticks: Bn(a, c, l, u, e),
      majorInterval: u
    };
  }, [t, e, n, i, o, r]);
  return t === 0 ? /* @__PURE__ */ d("div", { style: { display: "block", borderBottom: `1px solid ${N}`, height: U }, children: /* @__PURE__ */ d(ct, { component: "span", style: { height: "100%" }, children: /* @__PURE__ */ d(lr, { text: "No timeline data" }) }) }) : /* @__PURE__ */ M(
    "svg",
    {
      width: r,
      height: U,
      style: { display: "block", borderBottom: `1px solid ${N}` },
      children: [
        /* @__PURE__ */ d("rect", { x: 0, y: 0, width: r, height: U, fill: _ }),
        s.map((a, c) => {
          if (a.isMajor && a.time === 0) return null;
          const l = (a.time - n) * o;
          if (a.isMajor)
            return a.label ? /* @__PURE__ */ d(
              "text",
              {
                x: l,
                y: U / 2 - 2,
                fill: ut,
                fontSize: "0.75rem",
                dominantBaseline: "central",
                children: a.label
              },
              `${a.time}-${c}`
            ) : null;
          const u = Math.round(a.time / f) * f;
          if (Math.abs(a.time - u) * o < Kn) return null;
          const m = U - 12;
          return /* @__PURE__ */ d("rect", { x: l, y: m, width: 1, height: 2, fill: ut }, `${a.time}-${c}`);
        })
      ]
    }
  );
}
const Dt = "timeline-sidebar";
function jo({ trackId: t, displayIndex: e, children: n }) {
  const r = O(null), [i, o] = Q();
  return z(() => {
    if (!r.current) return;
    const s = lo({
      element: r.current,
      getInitialData: () => ({ type: Dt, trackId: t, displayIndex: e })
    }), f = so({
      element: r.current,
      getData: () => ({ type: Dt, trackId: t, displayIndex: e }),
      canDrop: ({ source: a }) => a.data.type === Dt && a.data.trackId !== t,
      onDragEnter: ({ source: a }) => {
        o(Number(a.data.displayIndex) > e ? "top" : "bottom");
      },
      onDragLeave: () => o(void 0),
      onDrop: () => o(void 0)
    });
    return () => {
      s(), f();
    };
  }, [t, e]), /* @__PURE__ */ M("div", { ref: r, style: { position: "relative" }, children: [
    i && /* @__PURE__ */ d(
      "div",
      {
        style: {
          position: "absolute",
          left: 0,
          right: 0,
          [i === "top" ? "top" : "bottom"]: 0,
          height: 2,
          background: en,
          zIndex: 1,
          pointerEvents: "none"
        }
      }
    ),
    n
  ] });
}
const Ho = {
  text: yo,
  image: bo,
  video: wo
};
function No({ track: t }) {
  const { onTrackSelect: e } = V(), n = Ho[t.type];
  return /* @__PURE__ */ M(
    q,
    {
      style: {
        height: te,
        justifyContent: "space-between",
        cursor: "pointer",
        padding: "0 8px",
        color: bt,
        borderBottom: `1px solid ${N}`,
        boxSizing: "border-box"
      },
      onMouseDown: (r) => {
        r.stopPropagation(), t.locked || e(t.id);
      },
      children: [
        /* @__PURE__ */ M(nt, { style: { gap: "4px" }, children: [
          /* @__PURE__ */ d(
            n,
            {
              style: { flexShrink: 0 },
              width: 16,
              height: 16,
              color: t.hidden ? ut : bt
            }
          ),
          /* @__PURE__ */ d(
            q,
            {
              style: {
                flex: 1,
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: t.hidden ? ut : bt
              },
              children: /* @__PURE__ */ d(dr, { text: t.name })
            }
          )
        ] }),
        /* @__PURE__ */ M(nt, { style: { gap: "2px" }, children: [
          /* @__PURE__ */ d(Fo, { track: t }),
          /* @__PURE__ */ d(Bo, { track: t }),
          /* @__PURE__ */ d(zo, { track: t })
        ] })
      ]
    }
  );
}
function Fo({ track: t }) {
  const { onTrackMuteToggle: e } = V();
  if (t.type !== "video") return null;
  const n = t.muted ?? !1;
  return /* @__PURE__ */ d(nn, { onToggle: () => e(t.id, !n), muted: n, size: "medium" });
}
function Bo({ track: t }) {
  const { onTrackVisibilityToggle: e } = V(), n = t.hidden;
  return /* @__PURE__ */ d(Co, { onToggle: () => e(t.id, !n), hidden: n });
}
function zo({ track: t }) {
  const { onTrackLockToggle: e, onTrackSelect: n, selectedTrackId: r } = V(), i = t.locked;
  return /* @__PURE__ */ d(
    Lo,
    {
      onToggle: () => {
        const o = !i;
        e(t.id, o), o && r === t.id && n(null);
      },
      locked: i
    }
  );
}
function Go() {
  const t = O(null), e = O(null), n = O(null), r = C((p) => p.duration), i = C((p) => p.setContainerWidth), o = C((p) => p.tracks), { store: s, onSeek: f, onTrackSelect: a, onTrackReorder: c, selectedTrackId: l } = V();
  uo(t), fo(t), z(() => {
    const p = t.current;
    if (!p) return;
    const h = () => {
      i(p.clientWidth);
    };
    h();
    const g = new ResizeObserver(h);
    return g.observe(p), () => g.disconnect();
  }, [i]), po(e, n), z(() => co({
    canMonitor: ({ source: p }) => p.data.type === Dt,
    onDrop: ({ source: p, location: h }) => {
      const g = h.current.dropTargets[0];
      if (!g) return;
      const v = p.data.trackId, x = g.data.trackId;
      typeof v != "number" || typeof x != "number" || v !== x && c(v, x);
    }
  }), [c]);
  const u = O({
    active: !1,
    wasPlaying: !1
  }), b = D(
    (p) => {
      const h = s.getState();
      if (p.button !== 0 || h.duration === 0) return;
      u.current.active = !0, u.current.wasPlaying = h.isPlaying, document.body.style.cursor = "ew-resize", h.isPlaying && h.setPlaying(!1);
      function g(k, S = !1) {
        const w = t.current;
        if (!w) return;
        const y = s.getState(), { scrollPosition: T, duration: L, frameRate: P, tracks: W, setCurrentTime: E, setSnapIndicatorTime: I } = y, A = $(y), F = w.getBoundingClientRect(), H = k - F.left, R = jn(H, T, A), B = Math.round(R * P) / P, J = Math.max(0, Math.min(B, L)), pt = (S ? Ue : Ye) / A, mt = [0, L];
        for (const tt of W)
          mt.push(tt.startTime, tt.startTime + tt.duration);
        const { snappedEdge: ht, snapIndicator: ot } = ie(J, mt, pt);
        I(ot);
        const Lt = ot !== null ? ht : J;
        E(Lt), f(Lt);
      }
      const v = (k) => {
        u.current.active && g(k.clientX, k.shiftKey);
      }, x = () => {
        if (!u.current.active) return;
        u.current.active = !1, document.body.style.cursor = "";
        const { setSnapIndicatorTime: k, setPlaying: S } = s.getState();
        k(null), u.current.wasPlaying && S(!0), document.removeEventListener("mousemove", v), document.removeEventListener("mouseup", x);
      };
      g(p.clientX, p.shiftKey), document.addEventListener("mousemove", v), document.addEventListener("mouseup", x);
    },
    [f, s]
  ), m = D(() => a(null), [a]);
  return /* @__PURE__ */ d(
    Un,
    {
      className: "timeline-container",
      style: {
        flex: 1,
        minHeight: 0,
        background: _,
        borderTop: `1px solid ${N}`,
        fontFamily: "'DM Sans', sans-serif"
      },
      onMouseDown: m,
      children: /* @__PURE__ */ M(nt, { style: { flex: 1, minHeight: 0 }, children: [
        /* @__PURE__ */ M(
          "div",
          {
            style: {
              width: Vn,
              flexShrink: 0,
              display: "flex",
              flexDirection: "column",
              background: _,
              borderRight: `1px solid ${N}`
            },
            children: [
              /* @__PURE__ */ d("div", { style: { height: U, flexShrink: 0, borderBottom: `1px solid ${N}` } }),
              /* @__PURE__ */ d(
                "div",
                {
                  ref: n,
                  className: "timeline-sidebar-scroll",
                  style: {
                    flex: 1,
                    minHeight: 0,
                    overflowY: "hidden",
                    borderBottom: o?.length ? "none" : `1px solid ${N}`
                  },
                  children: o.map((p, h) => /* @__PURE__ */ d(jo, { trackId: p.id, displayIndex: h, children: /* @__PURE__ */ d(No, { track: p }) }, p.id))
                }
              ),
              r > 0 && /* @__PURE__ */ d("div", { style: { height: le, flexShrink: 0 } })
            ]
          }
        ),
        /* @__PURE__ */ M(
          "div",
          {
            ref: t,
            style: {
              position: "relative",
              flex: 1,
              minWidth: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              cursor: "pointer",
              userSelect: "none"
            },
            onMouseDown: b,
            children: [
              /* @__PURE__ */ M(
                "div",
                {
                  style: {
                    position: "relative",
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    flexDirection: "column"
                  },
                  children: [
                    /* @__PURE__ */ d(Ro, {}),
                    /* @__PURE__ */ d(
                      "div",
                      {
                        ref: e,
                        className: "timeline-tracks-scroll",
                        style: {
                          flex: 1,
                          minHeight: 0,
                          overflowY: "auto"
                        },
                        children: /* @__PURE__ */ d("div", { style: { position: "relative" }, children: o.length === 0 ? /* @__PURE__ */ d(
                          "div",
                          {
                            style: {
                              position: "relative",
                              height: te,
                              background: _,
                              borderBottom: `1px solid ${N}`,
                              boxSizing: "border-box"
                            }
                          }
                        ) : o.map((p) => /* @__PURE__ */ d(Io, { track: p, isSelected: p.id === l }, p.id)) })
                      }
                    ),
                    /* @__PURE__ */ d(Oo, {}),
                    /* @__PURE__ */ d(Wo, {})
                  ]
                }
              ),
              r > 0 && /* @__PURE__ */ M(
                nt,
                {
                  style: {
                    height: le,
                    flexShrink: 0,
                    borderTop: `1px solid ${N}`,
                    padding: `0 ${qe}px`
                  },
                  children: [
                    /* @__PURE__ */ d("div", { style: { width: Ge, flexShrink: 0 }, children: /* @__PURE__ */ d(Eo, {}) }),
                    /* @__PURE__ */ d(Po, {})
                  ]
                }
              )
            ]
          }
        )
      ] })
    }
  );
}
export {
  te as DEFAULT_TRACK_HEIGHT,
  Zo as PLAYBACK_CONTROLS_HEIGHT,
  Uo as PlaybackControls,
  U as RULER_HEIGHT,
  le as SCROLLBAR_AREA_HEIGHT,
  Go as Timeline,
  Yo as TimelineProvider
};
